// AUTO-GENERATED. Do not edit by hand.
// Source: NextMarsItems Scriptable objects/*.asset (LitLegion Unity project)
// Regenerate with: npx tsx scripts/extract-litsquad-avatar-transforms.ts

/**
 * One Unity-local transform for an accessory sprite, expressed in the
 * coordinate system Unity authors them in: world units, Y up,
 * rotation radians around Z (positive = counter-clockwise).
 *
 * `spriteLayerNumber` is the SpriteRenderer.sortingOrder value used
 * by Unity. Higher = drawn on top. The web compositor sorts visible
 * accessory layers by this number.
 */
export interface AccessoryTransform {
  /** World position in Unity units, relative to the avatar root. */
  readonly position: { readonly x: number; readonly y: number };
  /** Rotation around Z in radians (positive = counter-clockwise). */
  readonly rotationRadians: number;
  /** Per-axis local scale multiplier. */
  readonly scale: { readonly x: number; readonly y: number };
  /** Unity SpriteRenderer.sortingOrder. */
  readonly spriteLayerNumber: number;
  /**
   * HandsType for two-handed pose variants on `holdingRight_*` items.
   * Other accessory groups always emit a single variant with
   * `handsType = 0`.
   */
  readonly handsType: number;
}

/**
 * Per-character (index 0..16) transform data for one accessory. Each
 * character can have multiple variants — `holdingRight_*` items have
 * three (one per HandsType pose); other groups have one.
 *
 * A character bucket may be empty if the upstream Unity asset has no
 * entry for that character (rare — most accessories cover all 17).
 */
export type AccessoryTransformsByCharacter = readonly (readonly AccessoryTransform[])[];

export interface AccessoryTransformEntry {
  readonly avatarGroup: number;
  readonly avatarItemsSubGroup: number;
  readonly perCharacter: AccessoryTransformsByCharacter;
}

/**
 * The HandsType variant the avatar editor picks when an accessory has
 * multiple pose variants. `0` is the default standing pose Unity
 * authors against — the other variants (1, 2) are alternative arm
 * positions used in the in-game character flow.
 */
export const DEFAULT_HANDS_TYPE = 0;

export const LITSQUAD_ACCESSORY_TRANSFORMS: Readonly<Record<string, AccessoryTransformEntry>> = {
  earringLeft_bigRing: {
    avatarGroup: 5,
    avatarItemsSubGroup: 8,
    perCharacter: [
      [
        {
          position: { x: -0.88000107, y: 11.710001 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 120,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.2, y: 11.59 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 338,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: 0.007, y: 11.341 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 379,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.86, y: 12.019 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 418,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.098, y: 11.269 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 418,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.86999893, y: 11.73 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 431,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.44, y: 11.74 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 431,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.946, y: 10.849 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 1.805, y: 10.516 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.289, y: 10.08 },
          rotationRadians: 0,
          scale: { x: 1.2, y: 1.2 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.617, y: 11.227 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 1.006, y: 10.873 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 1.172, y: 10.073 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.887, y: 12.284 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.378, y: 11.658 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.78099847, y: 10.659 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 409,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.8379991, y: 10.382 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 409,
          handsType: 0,
        },
      ],
    ],
  },
  earringLeft_leaves: {
    avatarGroup: 5,
    avatarItemsSubGroup: 8,
    perCharacter: [
      [
        {
          position: { x: -0.88000107, y: 11.710001 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 120,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.040000916, y: 11.515001 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 387,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.007, y: 11.341 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 379,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.86, y: 12.019 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 418,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.098, y: 11.269 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 418,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.86999893, y: 11.73 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 431,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.44, y: 11.74 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 431,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.946, y: 10.849 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 1.805, y: 10.516 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.289, y: 10.08 },
          rotationRadians: 0,
          scale: { x: 1.2, y: 1.2 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.617, y: 11.227 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 418,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 1.006, y: 10.873 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 418,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 1.172, y: 10.073 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 418,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.887, y: 12.284 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 418,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.378, y: 11.658 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.78099847, y: 10.659 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 409,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.8379991, y: 10.382 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 409,
          handsType: 0,
        },
      ],
    ],
  },
  earringLeft_moon: {
    avatarGroup: 5,
    avatarItemsSubGroup: 8,
    perCharacter: [
      [
        {
          position: { x: -0.88000107, y: 11.710001 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 120,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.2, y: 11.59 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 338,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: 0.007, y: 11.341 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 379,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.86, y: 12.019 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 418,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.098, y: 11.269 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 418,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.86999893, y: 11.73 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 431,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.44, y: 11.74 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 431,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.946, y: 10.849 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 1.805, y: 10.516 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.289, y: 10.08 },
          rotationRadians: 0,
          scale: { x: 1.2, y: 1.2 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.617, y: 11.227 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 412,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 1.006, y: 10.873 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 412,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 1.172, y: 10.073 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 412,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.887, y: 12.284 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 412,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.378, y: 11.658 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.78099847, y: 10.659 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 409,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.8379991, y: 10.382 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 409,
          handsType: 0,
        },
      ],
    ],
  },
  earringLeft_waterDrop: {
    avatarGroup: 5,
    avatarItemsSubGroup: 8,
    perCharacter: [
      [
        {
          position: { x: -0.88000107, y: 11.710001 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 120,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.2, y: 11.59 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 338,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: 0.007, y: 11.341 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 379,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.86, y: 12.019 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 418,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.098, y: 11.269 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 418,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.87, y: 11.73 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 431,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.44, y: 11.74 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 431,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.946, y: 10.849 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 1.805, y: 10.516 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.289, y: 10.08 },
          rotationRadians: 0,
          scale: { x: 1.2, y: 1.2 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.617, y: 11.227 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 475,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 1.006, y: 10.873 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 475,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 1.172, y: 10.073 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 475,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.887, y: 12.284 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 440,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.378, y: 11.658 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.781, y: 10.659 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 409,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.838, y: 10.382 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 409,
          handsType: 0,
        },
      ],
    ],
  },
  eyeCovering_glassesSun1: {
    avatarGroup: 5,
    avatarItemsSubGroup: 5,
    perCharacter: [
      [
        {
          position: { x: -2.369999, y: 11.5 },
          rotationRadians: 0.041580582,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 235,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4, y: 11.525 },
          rotationRadians: 0.041580582,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 359,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.274, y: 11.896 },
          rotationRadians: 0.041580582,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 359,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.201, y: 11.419 },
          rotationRadians: 0.041580582,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 390,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.713, y: 11.414 },
          rotationRadians: 0.12374874,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 395,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.55, y: 11.86 },
          rotationRadians: 0.041580582,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.94, y: 11.08 },
          rotationRadians: 0.041580582,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.097, y: 11.172 },
          rotationRadians: 0.041580582,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 367,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.864, y: 12.05 },
          rotationRadians: -0.14736196,
          scale: { x: 1.2, y: 1.2 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.571, y: 9.518 },
          rotationRadians: -0.11320991,
          scale: { x: 1.3, y: 1.3 },
          spriteLayerNumber: 3811,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.294, y: 10.978 },
          rotationRadians: -0.027994212,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.377, y: 11.298 },
          rotationRadians: -0.027994212,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.73600006, y: 10.375 },
          rotationRadians: -0.1976251,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.297, y: 12.361 },
          rotationRadians: 0.080945952,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 350,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.1040001, y: 11.435001 },
          rotationRadians: 0.044563146,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 350,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.999, y: 11.127 },
          rotationRadians: 0.11620448,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 375,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.451, y: 10.417 },
          rotationRadians: 0.11620448,
          scale: { x: 1.1288244, y: 0.9132 },
          spriteLayerNumber: 375,
          handsType: 0,
        },
      ],
    ],
  },
  eyeCovering_glassesSun2: {
    avatarGroup: 5,
    avatarItemsSubGroup: 5,
    perCharacter: [
      [
        {
          position: { x: -2.2999992, y: 11.34 },
          rotationRadians: 0.095473447,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 235,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.406, y: 11.484 },
          rotationRadians: 0.095473447,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 390,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.149, y: 11.828 },
          rotationRadians: 0.095473447,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 390,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.283, y: 11.321 },
          rotationRadians: 0.095473447,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 388,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.78, y: 11.373 },
          rotationRadians: 0.1776416,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 380,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.59, y: 11.74 },
          rotationRadians: 0.095473447,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 388,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.85, y: 10.92 },
          rotationRadians: 0.095473447,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 388,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.145, y: 11.158 },
          rotationRadians: 0.095473447,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 367,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.873, y: 12.013 },
          rotationRadians: -0.042532829,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 380,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.59, y: 9.514 },
          rotationRadians: -0.0070815607,
          scale: { x: 1.2, y: 1.2 },
          spriteLayerNumber: 364,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.296, y: 10.848 },
          rotationRadians: 0.04203704,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 380,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.297, y: 11.25 },
          rotationRadians: 0.04203704,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 380,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.703, y: 10.311 },
          rotationRadians: -0.042532829,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 380,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.246, y: 12.289 },
          rotationRadians: 0.14285469,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 380,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.052, y: 11.354 },
          rotationRadians: 0.067860672,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 380,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.006, y: 10.953 },
          rotationRadians: 0.15295334,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 408,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.4121, y: 10.3397 },
          rotationRadians: 0.15295334,
          scale: { x: 1.1288244, y: 0.9132 },
          spriteLayerNumber: 408,
          handsType: 0,
        },
      ],
    ],
  },
  eyeCovering_maskWithEyeLookouts: {
    avatarGroup: 5,
    avatarItemsSubGroup: 5,
    perCharacter: [
      [
        {
          position: { x: -2.1800003, y: 12.200001 },
          rotationRadians: 0.04725118,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 235,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.305, y: 12.194 },
          rotationRadians: 0.04725118,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 363,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.074, y: 12.596 },
          rotationRadians: 0.04725118,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 363,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.098, y: 12.173 },
          rotationRadians: 0.04725118,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 388,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.649, y: 12.267 },
          rotationRadians: 0.12941936,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 371,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.47, y: 12.52 },
          rotationRadians: 0.04725118,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 395,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.85, y: 11.72 },
          rotationRadians: 0.04725118,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 395,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.035, y: 11.6 },
          rotationRadians: 0.04725118,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 367,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.5, y: 13.057 },
          rotationRadians: -0.06215973,
          scale: { x: 1.3, y: 1.3 },
          spriteLayerNumber: 393,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.196, y: 10.52 },
          rotationRadians: -0.068900293,
          scale: { x: 1.3, y: 1.3 },
          spriteLayerNumber: 371,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.162, y: 11.655 },
          rotationRadians: 0.04725118,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 392,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.251, y: 12.086 },
          rotationRadians: 0.04725118,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 392,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.599, y: 11.027 },
          rotationRadians: -0.21504684,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 392,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.169, y: 12.828 },
          rotationRadians: 0.074716184,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 392,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.034, y: 11.86 },
          rotationRadians: 0.095081873,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 392,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.906, y: 11.725 },
          rotationRadians: 0.095081873,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 392,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.271, y: 10.858 },
          rotationRadians: 0.095081873,
          scale: { x: 1.2581, y: 0.7742 },
          spriteLayerNumber: 392,
          handsType: 0,
        },
      ],
    ],
  },
  faceCovering_beard1: {
    avatarGroup: 5,
    avatarItemsSubGroup: 10,
    perCharacter: [
      [
        {
          position: { x: -2.1500015, y: 10.35 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 234,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.956, y: 10.03 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 350,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.337, y: 10.941 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 350,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.298, y: 10.287 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.819, y: 10.357 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.75, y: 10.1 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 399,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.13, y: 9.54 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 351,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.3969994, y: 10.542001 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 353,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.558, y: 10.07 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 331,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.158, y: 7.873 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 353,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.403, y: 10.252 },
          rotationRadians: -0.10996328,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 353,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.658, y: 10.436 },
          rotationRadians: -0.27658114,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 346,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.984, y: 9.405 },
          rotationRadians: -0.41738537,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 353,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.32, y: 11.936 },
          rotationRadians: 0.063362855,
          scale: { x: 0.4, y: 0.4 },
          spriteLayerNumber: 350,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.996, y: 10.933 },
          rotationRadians: 0.0024505887,
          scale: { x: 0.4, y: 0.4 },
          spriteLayerNumber: 450,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.198, y: 9.408 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 450,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.3899994, y: 9.32 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 450,
          handsType: 0,
        },
      ],
    ],
  },
  faceCovering_beard2: {
    avatarGroup: 5,
    avatarItemsSubGroup: 10,
    perCharacter: [
      [
        {
          position: { x: -2.4167, y: 9.56 },
          rotationRadians: 0,
          scale: { x: 0.5638394, y: 1 },
          spriteLayerNumber: 234,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.104, y: 9.531 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 350,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.465, y: 10.317 },
          rotationRadians: 0,
          scale: { x: 0.8613, y: 1 },
          spriteLayerNumber: 350,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.525, y: 9.821 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.032, y: 9.8 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.15, y: 9.78 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 351,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.35, y: 9.32 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 351,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.604, y: 9.84 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 353,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.706, y: 9.275 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 331,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.208, y: 7.381 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 353,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.476, y: 9.865 },
          rotationRadians: 0.0080979611,
          scale: { x: 0.8, y: 0.6373855 },
          spriteLayerNumber: 353,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.556, y: 9.848 },
          rotationRadians: 0,
          scale: { x: 0.8613, y: 1 },
          spriteLayerNumber: 381,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.581, y: 9.245 },
          rotationRadians: -0.43186786,
          scale: { x: 0.8, y: 0.6373855 },
          spriteLayerNumber: 353,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.366, y: 11.55 },
          rotationRadians: 0,
          scale: { x: 0.45, y: 0.45 },
          spriteLayerNumber: 350,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.169, y: 10.604 },
          rotationRadians: 0,
          scale: { x: 0.4, y: 0.4 },
          spriteLayerNumber: 450,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.641, y: 9.341 },
          rotationRadians: 0,
          scale: { x: 0.7767, y: 0.68741846 },
          spriteLayerNumber: 450,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.625, y: 9.058 },
          rotationRadians: 0,
          scale: { x: 0.7767, y: 0.68741846 },
          spriteLayerNumber: 450,
          handsType: 0,
        },
      ],
    ],
  },
  faceCovering_beard3: {
    avatarGroup: 5,
    avatarItemsSubGroup: 10,
    perCharacter: [
      [
        {
          position: { x: -2.3199997, y: 10.53 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 234,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.063, y: 10.161 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 383,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.381, y: 11.062 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 350,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.341, y: 10.41 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.862, y: 10.396 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.96, y: 10.51 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 351,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.24, y: 9.55 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 351,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.408, y: 10.541 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 353,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.723, y: 10.218 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 331,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.157, y: 7.914 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 359,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.366, y: 10.332 },
          rotationRadians: -0.031494218,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 359,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.633, y: 10.465 },
          rotationRadians: -0.14849707,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 351,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.956, y: 9.485 },
          rotationRadians: -0.44350699,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 359,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.301, y: 12.029 },
          rotationRadians: 0.10508106,
          scale: { x: 0.45, y: 0.45 },
          spriteLayerNumber: 350,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.1039983, y: 11.019 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 450,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.318, y: 9.545 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 450,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.491, y: 9.432 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 450,
          handsType: 0,
        },
      ],
    ],
  },
  faceCovering_beard4: {
    avatarGroup: 5,
    avatarItemsSubGroup: 10,
    perCharacter: [
      [
        {
          position: { x: -2.2000008, y: 10.01 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 234,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.944, y: 9.688 },
          rotationRadians: 0,
          scale: { x: 1.126, y: 1 },
          spriteLayerNumber: 350,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.385, y: 10.567 },
          rotationRadians: 0,
          scale: { x: 1.126, y: 1 },
          spriteLayerNumber: 350,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.242, y: 9.94 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.819, y: 9.954 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 400,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.91, y: 9.97 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 351,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.19, y: 9.27 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 351,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.447, y: 10.213 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 353,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.592, y: 9.806 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 331,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.021, y: 7.318 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 353,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.406, y: 9.88 },
          rotationRadians: -0.063091234,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 359,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.477, y: 10.153 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 346,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.1269989, y: 9.138 },
          rotationRadians: -0.41165215,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 359,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.285, y: 11.711 },
          rotationRadians: 0,
          scale: { x: 0.45, y: 0.45 },
          spriteLayerNumber: 350,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.121, y: 10.76 },
          rotationRadians: -0.092633578,
          scale: { x: 0.4, y: 0.4 },
          spriteLayerNumber: 450,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.323, y: 9.241 },
          rotationRadians: -0.092633578,
          scale: { x: 0.8, y: 0.64264005 },
          spriteLayerNumber: 450,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.5149994, y: 9.153 },
          rotationRadians: -0.092633578,
          scale: { x: 0.8, y: 0.64264005 },
          spriteLayerNumber: 450,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_backwardsBaseballHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.6860008, y: 13.016001 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.398, y: 13.048 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.895, y: 12.668 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.92, y: 12.841 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.0749999, y: 12.003999 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.12, y: 12.89 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 398,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.45, y: 12.46 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 398,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.71, y: 12.18 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.058, y: 13.276 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.178, y: 11.646 },
          rotationRadians: 0,
          scale: { x: 1.2, y: 1.2 },
          spriteLayerNumber: 324,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.59, y: 12.35 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.137, y: 12.846 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.16300006, y: 11.842 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.025, y: 13.522 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.631, y: 12.714 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.364, y: 12.415 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.959, y: 11.221 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.78642 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_bandana: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.7350998, y: 12.83 },
          rotationRadians: 0,
          scale: { x: 0.6899181, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.562, y: 12.83 },
          rotationRadians: 0,
          scale: { x: 0.59429544, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.9834, y: 12.626 },
          rotationRadians: 0,
          scale: { x: 0.360966, y: 0.648 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.894, y: 12.573 },
          rotationRadians: 0,
          scale: { x: 0.58096, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.045, y: 11.945 },
          rotationRadians: 0.082168147,
          scale: { x: 0.58096, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.11, y: 12.86 },
          rotationRadians: 0,
          scale: { x: 0.38318226, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.6536, y: 12.22 },
          rotationRadians: 0,
          scale: { x: 0.62711996, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.883, y: 12.093 },
          rotationRadians: 0,
          scale: { x: 0.32905, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.3401, y: 13.22 },
          rotationRadians: 0,
          scale: { x: 0.63567, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.776, y: 11.736 },
          rotationRadians: 0,
          scale: { x: 0.8296, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.6872, y: 12.323 },
          rotationRadians: 0,
          scale: { x: 0.5545238, y: 0.7 },
          spriteLayerNumber: 390,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.3992, y: 12.872 },
          rotationRadians: 0,
          scale: { x: 0.59481436, y: 1 },
          spriteLayerNumber: 390,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.0008, y: 11.6925 },
          rotationRadians: -0.27633353,
          scale: { x: 0.59264004, y: 0.8 },
          spriteLayerNumber: 390,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.0972, y: 13.565 },
          rotationRadians: 0,
          scale: { x: 0.50837123, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.701, y: 12.582 },
          rotationRadians: 0,
          scale: { x: 0.4338, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.7, y: 12.162 },
          rotationRadians: 0,
          scale: { x: 0.53019, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.944, y: 11.116 },
          rotationRadians: 0.068273959,
          scale: { x: 0.68301, y: 0.68661 },
          spriteLayerNumber: 346,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_beret: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -2.2060013, y: 13.177 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.933, y: 13.21 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.108, y: 12.899 },
          rotationRadians: -0.12585332,
          scale: { x: 0.5819838, y: 0.72498995 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.46, y: 12.889 },
          rotationRadians: 0.0049670829,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.6526222, y: 12.160273 },
          rotationRadians: 0.087135236,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.27, y: 12.96 },
          rotationRadians: -0.10641672,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.7200007, y: 12.580001 },
          rotationRadians: -0.10641672,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.993, y: 12.238 },
          rotationRadians: -0.10856136,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.428, y: 13.548 },
          rotationRadians: -0.10641672,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.442, y: 12.09 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.817, y: 12.7 },
          rotationRadians: -0.15752797,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 373,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.6387, y: 13.209 },
          rotationRadians: -0.15752797,
          scale: { x: 0.807792, y: 0.9 },
          spriteLayerNumber: 373,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.079, y: 12.061 },
          rotationRadians: -0.42809694,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 373,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.272, y: 13.654 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.9262, y: 12.8686 },
          rotationRadians: -0.13016946,
          scale: { x: 0.64351, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.9824, y: 12.5429 },
          rotationRadians: -0.094971624,
          scale: { x: 0.7389861, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.154, y: 11.546 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_boaterHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -2.0340004, y: 13.241001 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.759, y: 13.228 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.992, y: 12.914 },
          rotationRadians: -0.13658933,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.266, y: 12.889 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.4592781, y: 12.176197 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.28, y: 13.18 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.67, y: 12.48 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.894001, y: 12.121002 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.294, y: 13.529 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.244, y: 11.838 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.957, y: 12.604 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.555, y: 13.036 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.098, y: 11.93 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.145, y: 13.514 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.753, y: 12.78 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.807, y: 12.487 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.2039986, y: 11.515 },
          rotationRadians: -0.073700931,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_bobbleHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.6800003, y: 13.370001 },
          rotationRadians: 0,
          scale: { x: 1.0686271, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.465, y: 13.279 },
          rotationRadians: 0,
          scale: { x: 1.0686271, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.9229, y: 12.934 },
          rotationRadians: 0,
          scale: { x: 0.6160911, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.877, y: 13.025 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.0827522, y: 12.343662 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.07, y: 13.05 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.5200007, y: 12.670001 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.777, y: 12.241 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.108, y: 13.674 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.998, y: 12.168 },
          rotationRadians: 0,
          scale: { x: 1.3, y: 1.3 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.572, y: 12.789 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 381,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.298, y: 13.318 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 381,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.124, y: 12.067 },
          rotationRadians: -0.27633353,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 381,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.04, y: 13.688 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 374,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.772, y: 12.971 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.838, y: 12.6414 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.96456003 },
          spriteLayerNumber: 374,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.088, y: 11.672 },
          rotationRadians: 0.14066652,
          scale: { x: 1.180987, y: 1 },
          spriteLayerNumber: 331,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_bucketHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -2, y: 13.380001 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.602, y: 13.363 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.999, y: 12.975 },
          rotationRadians: -0.14241863,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.218, y: 12.979 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.4188232, y: 12.269831 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.28, y: 13.05 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.77, y: 12.53 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.8600006, y: 12.260002 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.398, y: 13.56 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.2739983, y: 11.970001 },
          rotationRadians: -0.092756602,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.843, y: 12.51 },
          rotationRadians: -0.15503432,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 402,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.442, y: 12.997 },
          rotationRadians: -0.15503432,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 402,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.026, y: 12.002 },
          rotationRadians: -0.37766597,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 402,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.008, y: 13.589 },
          rotationRadians: -0.13860864,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.808, y: 12.825 },
          rotationRadians: -0.083597266,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.793, y: 12.428 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.154, y: 11.483 },
          rotationRadians: -0.083597266,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_bunnyEarsHeadband: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.9199982, y: 13.290001 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.396, y: 13.133 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.984, y: 12.822 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.843, y: 12.931 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.152, y: 12.089 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.03, y: 12.89 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.4800007, y: 12.510001 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.931, y: 12.133 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.072, y: 13.446 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.022, y: 11.991 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.629, y: 12.66 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 382,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.3, y: 13.384 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 382,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.432, y: 11.772 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 382,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.069, y: 13.523 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 327,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.58, y: 12.786 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 365,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.279, y: 12.254 },
          rotationRadians: 0,
          scale: { x: 1, y: 0.70907354 },
          spriteLayerNumber: 365,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.139, y: 11.482 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 367,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_chefHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.5299988, y: 13.59 },
          rotationRadians: 0,
          scale: { x: 1.1485838, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.402, y: 13.541 },
          rotationRadians: 0,
          scale: { x: 0.91630507, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.836, y: 13.467 },
          rotationRadians: 0,
          scale: { x: 0.6254712, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.939, y: 13.217 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.26, y: 12.424 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.01, y: 13.31 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.4600008, y: 12.930001 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.772, y: 12.515 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.036, y: 13.932 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.95, y: 12.426 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.544, y: 13.081 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 390,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.215, y: 13.623 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 390,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.307, y: 12.322 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 390,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.007, y: 13.878 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.679, y: 13.144 },
          rotationRadians: 0,
          scale: { x: 0.65163, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.5687, y: 12.861 },
          rotationRadians: 0,
          scale: { x: 0.8343994, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.054, y: 11.987 },
          rotationRadians: 0.2025727,
          scale: { x: 0.97643656, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_christmasHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.4399986, y: 13.460001 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.334, y: 13.549 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.827, y: 13.01 },
          rotationRadians: 0,
          scale: { x: 0.45900136, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.6, y: 13.104 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.981, y: 12.214 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 342,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2, y: 13.22 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.4, y: 12.64 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.736, y: 12.313 },
          rotationRadians: 0,
          scale: { x: 0.4, y: 0.4 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.134, y: 13.676 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.482, y: 12.306 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.516, y: 12.829 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.199, y: 13.309 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.301, y: 12.048 },
          rotationRadians: -0.27633353,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 376,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.1208, y: 13.763 },
          rotationRadians: 0,
          scale: { x: 0.54336005, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.55, y: 12.928 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.36, y: 12.691 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 391,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.839, y: 11.722 },
          rotationRadians: 0.084311122,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 391,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_chupallaHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -2.0200005, y: 13.27 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.591, y: 13.303 },
          rotationRadians: -0.2042805,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.929, y: 12.995 },
          rotationRadians: -0.2042805,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.118, y: 12.841 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.501, y: 12.187 },
          rotationRadians: -0.053487071,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.23, y: 12.98 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.8, y: 12.64 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.935, y: 12.195 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.412, y: 13.6 },
          rotationRadians: -0.11118345,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.286, y: 11.976 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.899, y: 12.633 },
          rotationRadians: -0.11932805,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.079, y: 13.127 },
          rotationRadians: -0.56856862,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 386,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.13, y: 11.897 },
          rotationRadians: -0.56856862,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 386,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.106, y: 13.648 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.803, y: 12.829 },
          rotationRadians: -0.10438017,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.648, y: 12.514 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.098, y: 11.471 },
          rotationRadians: -0.075169748,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_clocheHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -2.0800018, y: 13.23 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.685, y: 13.279 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.945, y: 12.811 },
          rotationRadians: -0.28564182,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.291, y: 12.991 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.457, y: 12.036 },
          rotationRadians: -0.066530611,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.22, y: 13.11 },
          rotationRadians: -0.13652203,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.61, y: 12.51 },
          rotationRadians: -0.13652203,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.9400024, y: 12.228 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.293, y: 13.516 },
          rotationRadians: -0.19053075,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.3400002, y: 11.988001 },
          rotationRadians: -0.12787917,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.85, y: 12.649 },
          rotationRadians: -0.1530097,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.479, y: 13.093 },
          rotationRadians: -0.1530097,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.049, y: 11.907 },
          rotationRadians: -0.55797468,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.172, y: 13.713 },
          rotationRadians: -0.11042489,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.77199936, y: 12.835 },
          rotationRadians: -0.14989176,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.8250008, y: 12.564001 },
          rotationRadians: -0.10217919,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.1860008, y: 11.489 },
          rotationRadians: -0.11042489,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_coonskinHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.5099983, y: 12.65 },
          rotationRadians: -0.088277939,
          scale: { x: 0.9000001, y: 0.9000001 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.095, y: 12.749 },
          rotationRadians: -0.088277939,
          scale: { x: 0.9000001, y: 0.9000001 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.845, y: 12.504 },
          rotationRadians: -0.088277939,
          scale: { x: 0.49573997, y: 0.41929004 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.63, y: 12.446 },
          rotationRadians: -0.088277939,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.894, y: 11.81 },
          rotationRadians: -0.0061097837,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.91, y: 12.71 },
          rotationRadians: -0.088277939,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.35, y: 12.11 },
          rotationRadians: -0.088277939,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.716, y: 11.967 },
          rotationRadians: -0.088277939,
          scale: { x: 0.4, y: 0.4 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.094, y: 13.112 },
          rotationRadians: -0.088277939,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.7519989, y: 11.544001 },
          rotationRadians: -0.11921776,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.598, y: 12.155 },
          rotationRadians: -0.088277939,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 357,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.099, y: 12.697 },
          rotationRadians: -0.1866437,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 357,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.203, y: 11.471 },
          rotationRadians: -0.47487394,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 357,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.215, y: 13.202 },
          rotationRadians: -0.088277939,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 363,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.575, y: 12.367 },
          rotationRadians: -0.14751497,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 369,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.411, y: 12.116 },
          rotationRadians: -0.14751497,
          scale: { x: 0.6127012, y: 0.5 },
          spriteLayerNumber: 369,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.785, y: 11.068 },
          rotationRadians: 0,
          scale: { x: 0.84483, y: 0.52486 },
          spriteLayerNumber: 369,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_crown1: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -2.019001, y: 13.249001 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.642, y: 13.196 },
          rotationRadians: 0,
          scale: { x: 0.78938997, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.062, y: 12.929 },
          rotationRadians: 0,
          scale: { x: 0.5181, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.198, y: 12.893 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.44, y: 12.2 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 329,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.26, y: 13.16 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.7, y: 12.54 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.919, y: 12.217 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 329,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.273, y: 13.543 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.21, y: 11.932 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.745, y: 12.662 },
          rotationRadians: 0,
          scale: { x: 0.75, y: 0.75 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.581, y: 13.222 },
          rotationRadians: 0,
          scale: { x: 0.85, y: 0.85 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.138, y: 11.923 },
          rotationRadians: -0.27633353,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.13, y: 13.548 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.766, y: 12.866 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.77, y: 12.647 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.255, y: 11.4515 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.74743545 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_crown2: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -2.0670013, y: 13.808001 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.72, y: 13.72 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.077, y: 13.15 },
          rotationRadians: 0,
          scale: { x: 0.7008, y: 0.7008 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.218, y: 13.129 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.56, y: 12.384 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.24, y: 13.29 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.91, y: 12.910001 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.991, y: 12.361 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.411, y: 13.874 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.646, y: 12.174 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.922, y: 13.061 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.147, y: 13.542 },
          rotationRadians: -0.27633353,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.007, y: 12.381 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.223, y: 13.923 },
          rotationRadians: -0.0044186373,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.92, y: 13.144 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.907, y: 12.897 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.2859993, y: 11.817 },
          rotationRadians: 0.082429734,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_crown3: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -2.012001, y: 13.220001 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.7416, y: 13.22 },
          rotationRadians: 0,
          scale: { x: 0.69664, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.017, y: 13.002 },
          rotationRadians: 0,
          scale: { x: 0.47292, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.083, y: 13.03 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.206, y: 12.232 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.21, y: 13.09 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.74, y: 12.64 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.881, y: 12.264 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.647, y: 13.586 },
          rotationRadians: 0,
          scale: { x: 0.76805997, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.058, y: 12.042 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.744, y: 12.633 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.483, y: 13.161 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.079, y: 11.884 },
          rotationRadians: -0.27633353,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.158, y: 13.612 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.803, y: 12.866 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.722, y: 12.538 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.33, y: 11.382 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.70928997 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_doctorialHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.8400002, y: 13.050001 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.454, y: 13.132 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.951, y: 12.858 },
          rotationRadians: 0,
          scale: { x: 0.4593, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.051, y: 12.769 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.098, y: 12.083 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 343,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.25, y: 12.99 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.7, y: 12.35 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.836, y: 12.139 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.166, y: 13.242 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.052, y: 11.862 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.702, y: 12.462 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 397,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.355, y: 13.033 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 397,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.033, y: 11.858 },
          rotationRadians: -0.27633353,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 397,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.036, y: 13.508 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.754, y: 12.712 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.787, y: 12.176 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.236, y: 11.319 },
          rotationRadians: 0.21859447,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_dunceHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -2.119999, y: 13.74 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.596, y: 13.74 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.1220016, y: 13.246 },
          rotationRadians: -0.010174596,
          scale: { x: 0.75, y: 0.75 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.205, y: 13.24 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.621, y: 12.408 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.31, y: 13.43 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.7800007, y: 12.99 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.962, y: 12.429 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.332, y: 13.836 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.646, y: 12.174 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.908, y: 12.999 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.616, y: 13.552 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.06600003, y: 12.113 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.325, y: 13.869 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.883, y: 13.027 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.81, y: 12.964 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.2170007, y: 11.741001 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_fedora: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -2.0099983, y: 13.17 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.598, y: 13.203 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.003, y: 12.913 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.147, y: 12.83 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.3358345, y: 12.127161 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.16, y: 13.05 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.75, y: 12.44 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.87, y: 12.05 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.318, y: 13.398 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.447, y: 11.846 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.73, y: 12.539 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.523, y: 13.032 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.112, y: 11.851 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.121, y: 13.453 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.778, y: 12.761 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.699, y: 12.504 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.255, y: 11.262 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 342,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_fez: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -2.0900002, y: 13.23 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.7037, y: 13.263 },
          rotationRadians: 0,
          scale: { x: 0.73592, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.0670013, y: 12.896 },
          rotationRadians: -0.10405026,
          scale: { x: 0.48237002, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.245, y: 12.864 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.4770012, y: 12.007 },
          rotationRadians: -0.03360095,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.33, y: 13.05 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.82, y: 12.39 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.995, y: 12.237 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.374, y: 13.5 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.162, y: 11.975 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.851, y: 12.647 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.614, y: 13.14 },
          rotationRadians: 0,
          scale: { x: 0.85, y: 0.85 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.02, y: 11.982 },
          rotationRadians: -0.39717889,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.131, y: 13.538 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.858, y: 12.792 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.826, y: 12.54 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.78091997 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.2109985, y: 11.432001 },
          rotationRadians: 0.061557515,
          scale: { x: 0.78111, y: 0.756 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  "headItem_firefighter'sHat": {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.7900009, y: 13.210001 },
          rotationRadians: -0.198575,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.251, y: 13.26 },
          rotationRadians: -0.198575,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.802, y: 12.928 },
          rotationRadians: -0.198575,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.785, y: 12.871 },
          rotationRadians: -0.198575,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.9784241, y: 12.197733 },
          rotationRadians: -0.11640686,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2, y: 13.09 },
          rotationRadians: -0.198575,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.53, y: 12.61 },
          rotationRadians: -0.198575,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.714, y: 12.217 },
          rotationRadians: -0.198575,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.505, y: 13.55 },
          rotationRadians: -0.198575,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.043, y: 11.905 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.712, y: 12.54 },
          rotationRadians: -0.198575,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.165, y: 12.936 },
          rotationRadians: -0.39041771,
          scale: { x: 0.85, y: 0.85 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.13, y: 11.884 },
          rotationRadians: -0.56907283,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 387,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.045, y: 13.464 },
          rotationRadians: -0.198575,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.661, y: 12.73 },
          rotationRadians: -0.20325052,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.637, y: 12.447 },
          rotationRadians: -0.17508147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.041, y: 11.483 },
          rotationRadians: -0.22660747,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_halfHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.9309998, y: 12.489 },
          rotationRadians: 0,
          scale: { x: 0.748, y: 1.0712 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.517, y: 12.514 },
          rotationRadians: 0,
          scale: { x: 0.748, y: 1.0712 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.798, y: 12.554 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.629, y: 12.542 },
          rotationRadians: 0,
          scale: { x: 0.72568005, y: 0.69704 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.7959442, y: 11.882648 },
          rotationRadians: 0.082168147,
          scale: { x: 0.72568005, y: 0.69704 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.87, y: 12.68 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.18, y: 12.07 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.836, y: 11.915 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.116, y: 13.068 },
          rotationRadians: 0,
          scale: { x: 0.72522, y: 0.70002 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.806, y: 11.634 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.676, y: 12.287 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 387,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.01, y: 12.75 },
          rotationRadians: -0.27633353,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 387,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.071, y: 11.537 },
          rotationRadians: -0.27633353,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 387,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.077, y: 13.371 },
          rotationRadians: 0.14726666,
          scale: { x: 0.6, y: 0.49824002 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.771, y: 12.558 },
          rotationRadians: 0,
          scale: { x: 0.4, y: 0.4 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.616, y: 12.102 },
          rotationRadians: 0.052895019,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 382,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.915, y: 11.073 },
          rotationRadians: 0.19384082,
          scale: { x: 0.8, y: 0.60111576 },
          spriteLayerNumber: 418,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_hardHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.9099998, y: 13.07 },
          rotationRadians: -0.18871524,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.719, y: 13.128 },
          rotationRadians: -0.18871524,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.979, y: 12.902 },
          rotationRadians: -0.18871524,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.002, y: 12.831 },
          rotationRadians: -0.18871524,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.2779922, y: 12.168047 },
          rotationRadians: -0.10654713,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.21, y: 13.05 },
          rotationRadians: -0.18871524,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.52, y: 12.43 },
          rotationRadians: -0.18871524,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.861, y: 12.214 },
          rotationRadians: -0.18871524,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.29, y: 13.412 },
          rotationRadians: -0.18871524,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.238, y: 11.778 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.845, y: 12.452 },
          rotationRadians: -0.18871524,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.455, y: 12.817 },
          rotationRadians: -0.18871524,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.006, y: 11.858 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.135, y: 13.458 },
          rotationRadians: -0.18871524,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.7599983, y: 12.681 },
          rotationRadians: -0.091306511,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.719, y: 12.491 },
          rotationRadians: -0.18871524,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.091, y: 11.432 },
          rotationRadians: -0.12728781,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_headItem_tiaras1: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.8460007, y: 12.939001 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.59, y: 13.01 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.871, y: 12.862 },
          rotationRadians: 0,
          scale: { x: 0.6507, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.818, y: 12.855 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.145, y: 12.097 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.14, y: 13.02 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.5900009, y: 12.640001 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.788, y: 12.228 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.058, y: 13.377 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.124, y: 11.826 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.695, y: 12.504 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.416, y: 12.991 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.15, y: 11.773 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.155, y: 13.51 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.698, y: 12.662 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.644, y: 12.463 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.135, y: 11.319 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_headband: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.9119987, y: 12.49 },
          rotationRadians: 0,
          scale: { x: 0.7396484, y: 1.289855 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.538, y: 12.511 },
          rotationRadians: 0,
          scale: { x: 0.7396484, y: 1.289855 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.012, y: 12.505 },
          rotationRadians: 0,
          scale: { x: 0.3781463, y: 0.5014866 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.7172, y: 12.512 },
          rotationRadians: 0,
          scale: { x: 0.7372078, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.0667, y: 11.6943 },
          rotationRadians: 0.082168147,
          scale: { x: 0.64173937, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.96, y: 12.62 },
          rotationRadians: 0,
          scale: { x: 0.49656, y: 0.67264 },
          spriteLayerNumber: 368,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.3618, y: 12.05 },
          rotationRadians: 0,
          scale: { x: 0.75356996, y: 0.9 },
          spriteLayerNumber: 368,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.859, y: 11.907 },
          rotationRadians: 0,
          scale: { x: 0.37825, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.377, y: 12.969 },
          rotationRadians: 0.080647462,
          scale: { x: 0.5999091, y: 0.78002995 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.62, y: 11.598 },
          rotationRadians: 0,
          scale: { x: 0.9493, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.48, y: 12.27 },
          rotationRadians: 0,
          scale: { x: 0.6671, y: 1 },
          spriteLayerNumber: 391,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.419, y: 12.706 },
          rotationRadians: 0,
          scale: { x: 0.6671, y: 1 },
          spriteLayerNumber: 395,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.12, y: 11.591 },
          rotationRadians: -0.27633353,
          scale: { x: 0.60464, y: 0.8 },
          spriteLayerNumber: 395,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.077, y: 13.401 },
          rotationRadians: 0.27169699,
          scale: { x: 0.50976515, y: 0.62856 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.8026, y: 12.49 },
          rotationRadians: 0,
          scale: { x: 0.4, y: 0.4 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.7401009, y: 12.069601 },
          rotationRadians: 0.13872754,
          scale: { x: 0.57834, y: 0.72120845 },
          spriteLayerNumber: 391,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.1914, y: 10.8286 },
          rotationRadians: 0.15990456,
          scale: { x: 0.9, y: 0.47572824 },
          spriteLayerNumber: 391,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_jokey: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.9119987, y: 13.43 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.6132, y: 13.322 },
          rotationRadians: 0,
          scale: { x: 0.71091294, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.0852, y: 12.883 },
          rotationRadians: 0,
          scale: { x: 0.52129847, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.065, y: 13.007 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.397, y: 12.199 },
          rotationRadians: 0.082168147,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.2, y: 13.09 },
          rotationRadians: 0.011408051,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.76, y: 12.49 },
          rotationRadians: 0.011408051,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.93, y: 12.33 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.244, y: 13.634 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.106, y: 12.408 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 382,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.82, y: 12.78 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.495, y: 13.361 },
          rotationRadians: 0,
          scale: { x: 0.85, y: 0.85 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.06600003, y: 12.113 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.002, y: 13.887 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.791, y: 12.965 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.79, y: 12.57 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.236, y: 11.665 },
          rotationRadians: 0.1564076,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_kettleBrimHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.9799995, y: 13.43 },
          rotationRadians: -0.22387901,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.557, y: 13.38 },
          rotationRadians: -0.22387901,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.947, y: 12.945 },
          rotationRadians: -0.22387901,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.072, y: 13.036 },
          rotationRadians: -0.22387901,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.2779961, y: 12.338625 },
          rotationRadians: -0.14171086,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.26, y: 13.11 },
          rotationRadians: -0.22387901,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.7100008, y: 12.73 },
          rotationRadians: -0.22387901,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.8400002, y: 12.310001 },
          rotationRadians: -0.22387901,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.294, y: 13.58 },
          rotationRadians: -0.22387901,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.646, y: 12.174 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.86, y: 12.781 },
          rotationRadians: -0.22387901,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.568, y: 13.043 },
          rotationRadians: -0.22387901,
          scale: { x: 0.85, y: 0.85 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.06600189, y: 12.113001 },
          rotationRadians: -0.50393669,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 390,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.146, y: 13.594 },
          rotationRadians: -0.22387901,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.784, y: 12.885 },
          rotationRadians: -0.20065299,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.945, y: 12.726 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.2170007, y: 11.741001 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_militaryHelmet: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.8499985, y: 11.780001 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.524, y: 11.997 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.144, y: 11.763 },
          rotationRadians: 0,
          scale: { x: 0.76, y: 0.76 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.181, y: 11.71 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.2777977, y: 11.008154 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.18, y: 12.23 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.57, y: 11.32 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.901, y: 11.615 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.284, y: 12.248 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.13, y: 10.698 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.858, y: 11.388 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.858, y: 11.388 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.38, y: 10.891 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.153, y: 12.875 },
          rotationRadians: 0.085291547,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.741, y: 11.835 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.738, y: 11.257 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.148, y: 10.223 },
          rotationRadians: 0.085291547,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  "headItem_sailor'sHat": {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -2.177002, y: 13.171 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.771, y: 13.269 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.205, y: 12.784 },
          rotationRadians: -0.074611744,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.205, y: 12.784 },
          rotationRadians: -0.074611744,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.3898621, y: 12.076555 },
          rotationRadians: 0.0075564081,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.36, y: 13.05 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.8, y: 12.43 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.0370026, y: 12.051001 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.413, y: 13.495 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.35, y: 11.98 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.873, y: 12.522 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.636, y: 13.039 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.001, y: 11.923 },
          rotationRadians: -0.39943194,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.218, y: 13.454 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.92, y: 12.662 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.81, y: 12.401 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.374, y: 11.539 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_sombrero: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.9799995, y: 13.49 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.653, y: 13.542 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.15, y: 13.074 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.332, y: 13.117 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.5437698, y: 12.39801 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.35, y: 13.21 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.63, y: 12.71 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.931, y: 12.506 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.408, y: 13.922 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.166, y: 12.12 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.989, y: 12.884 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.369, y: 13.518 },
          rotationRadians: -0.096315905,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.06600003, y: 12.113 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 390,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.255, y: 13.818 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.833, y: 13.027 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.717, y: 12.705 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.2170007, y: 11.691 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_strawHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.9099998, y: 13.16 },
          rotationRadians: -0.3131765,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.421, y: 13.193 },
          rotationRadians: -0.3131765,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.033, y: 13.002 },
          rotationRadians: -0.3131765,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.97, y: 12.905 },
          rotationRadians: -0.3131765,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.219, y: 12.127 },
          rotationRadians: -0.23100829,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.12, y: 13.05 },
          rotationRadians: -0.3131765,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.58, y: 12.6 },
          rotationRadians: -0.3131765,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.87, y: 12.14 },
          rotationRadians: -0.3131765,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.32, y: 13.478 },
          rotationRadians: -0.3131765,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.225071, y: 11.902428 },
          rotationRadians: -0.24362009,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.832, y: 12.413 },
          rotationRadians: -0.3131765,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.127, y: 12.797 },
          rotationRadians: -0.527184,
          scale: { x: 0.9, y: 0.97 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.118, y: 11.864 },
          rotationRadians: -0.527184,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.004, y: 13.587 },
          rotationRadians: -0.3131765,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.846, y: 12.73 },
          rotationRadians: -0.2722352,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.759, y: 12.545 },
          rotationRadians: -0.22256931,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.186, y: 11.552 },
          rotationRadians: -0.24487368,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_sunHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -2.0089989, y: 13.266001 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.747, y: 13.22 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.976, y: 12.811 },
          rotationRadians: -0.19249399,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.219, y: 12.938 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.4164658, y: 12.228888 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.54, y: 13.08 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.9900007, y: 12.700001 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.8689995, y: 12.146002 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.605, y: 13.542 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.237, y: 11.857 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.987, y: 12.647 },
          rotationRadians: -0.10988674,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.513, y: 13.018 },
          rotationRadians: -0.10988674,
          scale: { x: 0.85, y: 0.85 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.117, y: 11.956 },
          rotationRadians: -0.5017978,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 399,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.149, y: 13.629 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.674, y: 12.853 },
          rotationRadians: -0.14934781,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.818, y: 12.417 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.084, y: 11.501 },
          rotationRadians: -0.092407031,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_tiaras2: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.9421997, y: 12.790001 },
          rotationRadians: 0,
          scale: { x: 0.7882218, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.553, y: 12.782 },
          rotationRadians: 0,
          scale: { x: 0.7882218, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.441, y: 12.711 },
          rotationRadians: 0,
          scale: { x: 0.7882218, y: 0.7882218 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.449, y: 12.67 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.861, y: 11.89 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.06, y: 12.82 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.22, y: 12.19 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.748, y: 11.897 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.217, y: 13.096 },
          rotationRadians: 0,
          scale: { x: 0.61578, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.07, y: 11.507 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.739, y: 12.251 },
          rotationRadians: 0,
          scale: { x: 0.59301, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.498, y: 12.957 },
          rotationRadians: 0,
          scale: { x: 0.705, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.25, y: 11.507 },
          rotationRadians: -0.27633353,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 384,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.043, y: 13.212 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.772, y: 12.508 },
          rotationRadians: 0,
          scale: { x: 0.53585, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.604, y: 12.179 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 392,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.808, y: 11.061 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 335,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_tiaras3: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -2, y: 12.84 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.7957, y: 12.875 },
          rotationRadians: 0,
          scale: { x: 0.7676975, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.034, y: 12.709 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.951, y: 12.713 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.1308899, y: 12.026646 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.19, y: 12.89 },
          rotationRadians: 0,
          scale: { x: 0.55110997, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.71, y: 12.3 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.915, y: 12.048 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.398, y: 13.296 },
          rotationRadians: 0,
          scale: { x: 0.74862, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.106, y: 11.862 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.9220009, y: 12.521 },
          rotationRadians: 0.033603033,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 379,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.634, y: 12.946 },
          rotationRadians: 0.033603033,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 379,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.158, y: 11.852 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 379,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.23199844, y: 13.455 },
          rotationRadians: 0.071816244,
          scale: { x: 0.7, y: 0.53641003 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.858, y: 12.687 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.834, y: 12.267 },
          rotationRadians: 0.078559072,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.287, y: 11.105 },
          rotationRadians: 0.13892339,
          scale: { x: 1.04848, y: 0.61008 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_topHat: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -2, y: 13.57 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.53, y: 13.7 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.911, y: 13.21 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.965, y: 13.167 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.359, y: 12.463 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 353,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.32, y: 13.34 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 348,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.7700007, y: 12.960001 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 202,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.8100014, y: 12.450001 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 335,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.21, y: 13.668 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.646, y: 12.174 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.913, y: 12.927 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.505, y: 13.407 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.052, y: 12.078 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.151, y: 13.784 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.772, y: 12.971 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.753, y: 12.761 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.2170007, y: 11.741001 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_turban: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.8300018, y: 13.02 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.575, y: 12.883 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.994, y: 12.781 },
          rotationRadians: 0,
          scale: { x: 0.4717, y: 0.523 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.865, y: 12.844 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.161, y: 11.971 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.132, y: 12.89 },
          rotationRadians: 0,
          scale: { x: 0.5341901, y: 0.49212003 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.47, y: 12.32 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.845, y: 12.109 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.174, y: 13.364 },
          rotationRadians: 0,
          scale: { x: 0.7578, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.938, y: 11.832 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.618, y: 12.604 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 386,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.3782, y: 12.895 },
          rotationRadians: 0,
          scale: { x: 0.84897, y: 0.9 },
          spriteLayerNumber: 386,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.065, y: 11.805 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 386,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.089, y: 13.472 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 350,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.7317, y: 12.5853 },
          rotationRadians: 0,
          scale: { x: 0.60192996, y: 0.52037996 },
          spriteLayerNumber: 351,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.46, y: 12.244 },
          rotationRadians: 0,
          scale: { x: 0.91745836, y: 0.7902 },
          spriteLayerNumber: 351,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.2493, y: 11.1715 },
          rotationRadians: 0.10154556,
          scale: { x: 0.9, y: 0.7830663 },
          spriteLayerNumber: 333,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_watchCap: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.7855988, y: 12.9114 },
          rotationRadians: 0.19091562,
          scale: { x: 0.9236946, y: 0.95027405 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.622, y: 12.964 },
          rotationRadians: 0.34969634,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1, y: 12.716 },
          rotationRadians: 0.30627348,
          scale: { x: 0.52839494, y: 0.64239 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.031, y: 12.795 },
          rotationRadians: 0.34969634,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.282, y: 12.032 },
          rotationRadians: 0.43186451,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.19, y: 12.88 },
          rotationRadians: 0.32937296,
          scale: { x: 0.56958, y: 0.53580004 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.69, y: 12.33 },
          rotationRadians: 0.32937296,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.864, y: 12.092 },
          rotationRadians: 0.19091562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.159, y: 13.229 },
          rotationRadians: 0.19091562,
          scale: { x: 0.79622996, y: 0.84186 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.752, y: 11.523 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.5, y: 12.555 },
          rotationRadians: 0.19091562,
          scale: { x: 0.7464657, y: 0.75768 },
          spriteLayerNumber: 389,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.248, y: 12.728 },
          rotationRadians: 0.19091562,
          scale: { x: 0.85, y: 0.85 },
          spriteLayerNumber: 389,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.06600189, y: 11.976 },
          rotationRadians: 0.12943786,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 389,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.105, y: 13.458 },
          rotationRadians: 0.29555765,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 371,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.865, y: 12.774 },
          rotationRadians: 0.36291343,
          scale: { x: 0.5, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.8738, y: 12.4132 },
          rotationRadians: 0.42709991,
          scale: { x: 0.6717, y: 0.9859 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.293, y: 11.344 },
          rotationRadians: 0.4963878,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 328,
          handsType: 0,
        },
      ],
    ],
  },
  headItem_witch: {
    avatarGroup: 4,
    avatarItemsSubGroup: 12,
    perCharacter: [
      [
        {
          position: { x: -1.9300003, y: 13.68 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.677, y: 13.569 },
          rotationRadians: -0.074420791,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.82, y: 13.18 },
          rotationRadians: -0.074420791,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.205, y: 13.11 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.4166222, y: 12.401459 },
          rotationRadians: 0.082168147,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 366,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.1, y: 13.29 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.73, y: 12.98 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.863, y: 12.46 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.334, y: 13.842 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 430,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.264, y: 12.12 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 337,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.73, y: 12.957 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.34, y: 13.45 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.06600003, y: 12.113 },
          rotationRadians: -0.27633353,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 393,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.061, y: 13.814 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.772, y: 12.971 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.794, y: 12.813 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.2170007, y: 11.741001 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 420,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_100DollarBill: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.759, y: 6.151 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.93, y: 5.853 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.93, y: 5.853 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 35,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.396, y: 5.709 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.424, y: 5.582 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.396, y: 5.709 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 95,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.44, y: 6.46 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.44, y: 6.46 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.44, y: 6.46 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.35, y: 5.84 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.16, y: 5.98 },
          rotationRadians: -1.0995955,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 60,
          handsType: 2,
        },
        {
          position: { x: -4.16, y: 5.98 },
          rotationRadians: -1.0995955,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.19, y: 5.36 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.82, y: 5.47 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 6.43 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 1.1, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.523118, y: 7.5418954 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.247, y: 6.454 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.9078946, y: 5.794859 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.0737643, y: 5.0730853 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_apple: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.9, y: 5.8 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.9, y: 5.8 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.9, y: 5.8 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 36,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.323, y: 5.377 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 62,
          handsType: 2,
        },
        {
          position: { x: -4.323, y: 5.377 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.323, y: 5.377 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 85,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.44, y: 6.46 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.418, y: 6.338 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 66,
          handsType: 2,
        },
        {
          position: { x: -4.418, y: 6.338 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 66,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.188, y: 5.823 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.011, y: 6.221 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3, y: 6.054 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.205, y: 5.813 },
          rotationRadians: -1.0262939,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.777, y: 5.563 },
          rotationRadians: -1.0262939,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 66,
          handsType: 2,
        },
        {
          position: { x: -4.315, y: 6.131 },
          rotationRadians: -1.0262939,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.2, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.68, y: 5.33 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.35, y: 5.88 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.036, y: 6.485 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.8875976, y: 5.863328 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.1182003, y: 5.235965 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_badmintonRacket: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -5.054, y: 8.628 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
        {
          position: { x: -5.088, y: 8.521 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.963, y: 8.579 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.44, y: 7.79 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
        {
          position: { x: -5.37, y: 7.57 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -5.41, y: 7.75 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.98, y: 9.07 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
        {
          position: { x: -5.5, y: 8.82 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -5.13, y: 9.08 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.79, y: 7.88 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.08, y: 7.61 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.8, y: 7.96 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.05, y: 7.92 },
          rotationRadians: -0.14732244,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.88, y: 8.09 },
          rotationRadians: -0.14732244,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.97, y: 3.95 },
          rotationRadians: -4.0952068,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.72, y: 6.996 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.73, y: 7.85 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.57, y: 8.31 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.84, y: 7.8 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.424801, y: 6.8261895 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.4725924, y: 8.828851 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.369926, y: 6.999993 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.1873715, y: 7.1992645 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.317887, y: 9.4419 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.6474667, y: 7.930988 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.5510063, y: 7.361787 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.8295565, y: 6.332766 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_bagOfMoney: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.407, y: 5.948 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.602, y: 5.737 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.186, y: 5.394 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 25,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.13, y: 4.63 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.14, y: 4.49 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.17, y: 4.58 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 85,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.66, y: 5.88 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
        {
          position: { x: -4.07, y: 5.8 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -3.76, y: 5.77 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.783, y: 5.584 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -2.846, y: 5.098 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 63,
          handsType: 2,
        },
        {
          position: { x: -2.783, y: 5.584 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.742, y: 5.239 },
          rotationRadians: -0.70625461,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.742, y: 5.239 },
          rotationRadians: -0.70625461,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.742, y: 5.239 },
          rotationRadians: -0.70625461,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.941, y: 5.014 },
          rotationRadians: 0,
          scale: { x: 0.3, y: 0.3 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 4.82 },
          rotationRadians: -0.21566757,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.75, y: 5.88 },
          rotationRadians: 0,
          scale: { x: 0.4, y: 0.4 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.23, y: 5.96 },
          rotationRadians: -0.14428464,
          scale: { x: 0.4, y: 0.4 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.6977532, y: 4.806268 },
          rotationRadians: 0,
          scale: { x: 0.4, y: 0.4 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.08, y: 6.03 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.178455, y: 4.5380692 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.3, y: 0.3 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.2439854, y: 7.0857863 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9189987, y: 5.682 },
          rotationRadians: 0.29905823,
          scale: { x: 0.4, y: 0.4 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.7683854, y: 5.150487 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.107403, y: 4.609738 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_banana: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.919, y: 7.398 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 27,
          handsType: 0,
        },
        {
          position: { x: -4.097, y: 7.39 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 27,
          handsType: 2,
        },
        {
          position: { x: -4.293, y: 7.434 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 36,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.55, y: 6.95 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 73,
          handsType: 1,
        },
        {
          position: { x: -4.76, y: 6.74 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -4.44, y: 6.63 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.35, y: 7.93 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 73,
          handsType: 1,
        },
        {
          position: { x: -4.61, y: 7.4 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -4.07, y: 7.69 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.15, y: 6.963 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.252, y: 6.603 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -3.252, y: 6.603 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.5, y: 4.97 },
          rotationRadians: 3.7312582,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 76,
          handsType: 2,
        },
        {
          position: { x: -4.5, y: 4.97 },
          rotationRadians: 3.7312582,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 76,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.19, y: 6.22 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 76,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.76, y: 6.61 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.85, y: 7.2 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.38, y: 7.25 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4, y: 6.2 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.4743257, y: 7.752274 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 76,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.7637305, y: 6.503986 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 76,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.9673185, y: 7.060059 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 76,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.2188869, y: 8.390369 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 76,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.377, y: 7.44 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 76,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.11662, y: 6.720765 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2, y: 5.94 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_basketball: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.1299996, y: 5.24 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.215, y: 5.145 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.215, y: 5.145 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 36,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.645, y: 4.933 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 83,
          handsType: 1,
        },
        {
          position: { x: -4.691, y: 4.703 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 72,
          handsType: 2,
        },
        {
          position: { x: -4.691, y: 4.703 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.811, y: 5.705 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 2,
        },
        {
          position: { x: -4.47, y: 6.09 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
        {
          position: { x: -4.43, y: 5.96 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.34, y: 5.63 },
          rotationRadians: 0.11057562,
          scale: { x: 0.71, y: 0.71 },
          spriteLayerNumber: 79,
          handsType: 1,
        },
        {
          position: { x: -3.34, y: 5.63 },
          rotationRadians: 0.11057562,
          scale: { x: 0.71, y: 0.71 },
          spriteLayerNumber: 79,
          handsType: 0,
        },
        {
          position: { x: -3.61, y: 5.4 },
          rotationRadians: 0.11057562,
          scale: { x: 0.71, y: 0.71 },
          spriteLayerNumber: 75,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 79,
          handsType: 1,
        },
        {
          position: { x: -4.455, y: 5.208 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 79,
          handsType: 0,
        },
        {
          position: { x: -4.455, y: 5.208 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 63,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.345, y: 5.134 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.28, y: 5.11 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.09, y: 5.79 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.63, y: 5.89 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.1, y: 4.87 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.886814, y: 6.0908866 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 79,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.9297333, y: 4.5515857 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 79,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.7771447, y: 5.6476374 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 79,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9102466, y: 7.2496305 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.62, y: 6.215 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 90,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.301124, y: 5.2931976 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.5493155, y: 4.792046 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_battleAxe: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.63, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
        {
          position: { x: -4.94, y: 7.49 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.94, y: 7.49 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.145, y: 7.302 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -5.382, y: 7.207 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -5.294, y: 7.268 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.93, y: 8.23 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -5.163, y: 7.511 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 65,
          handsType: 2,
        },
        {
          position: { x: -4.85, y: 8 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.24, y: 7.405 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.949, y: 7.628 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.949, y: 7.628 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.7639356, y: 4.5030994 },
          rotationRadians: 2.0258505,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 74,
          handsType: 2,
        },
        {
          position: { x: -4.7639356, y: 4.5030994 },
          rotationRadians: 2.0258505,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
        {
          position: { x: -5.1058974, y: 7.168681 },
          rotationRadians: -0.046374837,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 74,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.82, y: 6.95 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.53, y: 7.31 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.55, y: 7.56 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.85, y: 7.77 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.5087676, y: 6.6045203 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.5938983, y: 8.37694 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.526757, y: 6.871234 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.1793501, y: 6.935875 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.434281, y: 9.117094 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.2623067, y: 7.7341366 },
          rotationRadians: 0.19637654,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.729866, y: 7.192172 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.9141183, y: 6.5128956 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_book: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.095, y: 5.913 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.222, y: 5.756 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.222, y: 5.756 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 36,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.918, y: 5.604 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 67,
          handsType: 2,
        },
        {
          position: { x: -4.918, y: 5.604 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
        {
          position: { x: -4.918, y: 5.604 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 85,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.44, y: 6.46 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 1,
        },
        {
          position: { x: -4.82, y: 6.3 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 2,
        },
        {
          position: { x: -4.38, y: 6.52 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.333, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.68, y: 5.904 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.68, y: 5.904 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.53, y: 4.96 },
          rotationRadians: -1.3052979,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.53, y: 4.96 },
          rotationRadians: -1.3052979,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.380001, y: 5.16 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.04, y: 5.43 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.02, y: 5.93 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 6.43 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.1078672, y: 5.1121655 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.773438, y: 6.516187 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.018758, y: 5.1730213 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.944111, y: 5.854555 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.800163, y: 7.712034 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.702, y: 6.277 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 92,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.282624, y: 5.707284 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.337939, y: 5.005631 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_bottle: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.938, y: 6.614 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.945, y: 6.36 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.938, y: 6.614 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 41,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.446, y: 5.801 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.446, y: 5.801 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.446, y: 5.801 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 85,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.44, y: 6.46 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
        {
          position: { x: -4.44, y: 6.46 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.44, y: 6.46 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.34, y: 6.14 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.11, y: 6.49 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.11, y: 6.49 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.87, y: 5.74 },
          rotationRadians: -1.0581545,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 62,
          handsType: 2,
        },
        {
          position: { x: -3.87, y: 5.74 },
          rotationRadians: -1.0581545,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.380001, y: 5.75 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.78, y: 5.84 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 6.43 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.5179732, y: 6.149074 },
          rotationRadians: 0.25870314,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.227, y: 6.671 },
          rotationRadians: 0.20980808,
          scale: { x: 0.55, y: 0.55 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.767, y: 6.111 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.1075215, y: 5.501834 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_bottleOfBeer: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.697, y: 6.767 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.819, y: 6.608 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.859, y: 6.465 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 37,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.68, y: 6.45 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.68, y: 6.45 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.68, y: 6.45 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 85,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.02, y: 6.94 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.3, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -4, y: 6.86 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.117, y: 6.652 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.179, y: 6.336 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.117, y: 6.652 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.14, y: 5.57 },
          rotationRadians: -0.83801338,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 61,
          handsType: 2,
        },
        {
          position: { x: -4.14, y: 5.57 },
          rotationRadians: -0.83801338,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.27, y: 5.88 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.83, y: 6.05 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.84, y: 6.62 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.34, y: 6.7 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9721625, y: 5.557981 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.868876 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.666109 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.9613533 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.283, y: 6.816 },
          rotationRadians: 0.23581266,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.9078298, y: 6.284357 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.193912, y: 5.5050287 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_cake: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.12, y: 5.61 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.26, y: 5.37 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.26, y: 5.37 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 40,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.91, y: 5.36 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
        {
          position: { x: -4.91, y: 5.36 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 74,
          handsType: 2,
        },
        {
          position: { x: -4.91, y: 5.36 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 84,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.57, y: 6.11 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 74,
          handsType: 1,
        },
        {
          position: { x: -4.91, y: 5.83 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 74,
          handsType: 2,
        },
        {
          position: { x: -4.56, y: 6.36 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.471, y: 6.131 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.744, y: 5.672 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.496, y: 5.883 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.92, y: 6.12 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.41, y: 5.66 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.41, y: 5.66 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.401, y: 5.219 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.02, y: 5.18 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.14, y: 5.91 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.68, y: 5.95 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.21, y: 4.94 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.8441734, y: 6.3324285 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.762811, y: 4.9220552 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.715691, y: 5.8584924 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.085228, y: 7.5951357 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.141, y: 6.613 },
          rotationRadians: -1.0690477,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.2842264, y: 5.625544 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.3224425, y: 5.019542 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_camera: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.91, y: 5.743 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.801, y: 5.48 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.801, y: 5.48 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 43,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.56, y: 5.4 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 85,
          handsType: 1,
        },
        {
          position: { x: -4.56, y: 5.4 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 78,
          handsType: 0,
        },
        {
          position: { x: -4.72, y: 5.16 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 72,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.82, y: 6.3 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 78,
          handsType: 0,
        },
        {
          position: { x: -4.9, y: 5.91 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -4.82, y: 6.3 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 78,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.63, y: 5.68 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.4, y: 5.94 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.4, y: 5.94 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.36, y: 5.31 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.36, y: 5.31 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.373, y: 5.255 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.12, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.12, y: 6.03 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.5, y: 6.14 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.15, y: 4.96 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.867118, y: 6.279482 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.639284, y: 4.9443655 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.6051378, y: 5.832146 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.8554153, y: 7.570667 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.805, y: 7.013 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.1218634, y: 5.7272854 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2620144, y: 4.9503913 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_candle: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.879, y: 7.941 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
        {
          position: { x: -4.136, y: 7.728 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.879, y: 7.941 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.637, y: 7.596 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
        {
          position: { x: -4.637, y: 7.596 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 74,
          handsType: 2,
        },
        {
          position: { x: -4.637, y: 7.596 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 74,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.83, y: 8.19 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 74,
          handsType: 2,
        },
        {
          position: { x: -4.37, y: 8.37 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
        {
          position: { x: -4.24, y: 8.18 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 74,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.13, y: 7.93 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.31, y: 7.15 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.13, y: 7.93 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.11, y: 8.02 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.8, y: 7.07 },
          rotationRadians: -0.38703004,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 2,
        },
        {
          position: { x: -3.8, y: 7.07 },
          rotationRadians: -0.38703004,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.302, y: 6.755 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.94, y: 7.29 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.85, y: 7.58 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.27, y: 7.65 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.0506964, y: 6.835047 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.6262984, y: 8.489443 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.004774, y: 7.0580616 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.9532733, y: 6.884575 },
          rotationRadians: 0.39360297,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.7692842, y: 9.292654 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.684, y: 7.809 },
          rotationRadians: 0.17455695,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.284295, y: 7.167902 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.3840146, y: 6.1499524 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_cards: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.15, y: 6.24 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.38, y: 5.96 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.38, y: 5.96 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 35,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.8, y: 5.39 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 65,
          handsType: 2,
        },
        {
          position: { x: -4.8, y: 5.39 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.8, y: 5.39 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 86,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.44, y: 6.46 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.66, y: 6.4 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -4.49, y: 6.85 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.11, y: 6.07 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.5, y: 5.8 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.28, y: 6.37 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.71, y: 5.15 },
          rotationRadians: 1.7444011,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.394, y: 5.495 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.09, y: 5.35 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 6.43 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.745671, y: 6.527348 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.8714128, y: 5.1598115 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.9175837, y: 5.956085 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.7359495, y: 7.5095377 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.627, y: 7.205 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.3002834, y: 5.745946 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.3135757, y: 5.1629167 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_chessPiece: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.349, y: 6.444 },
          rotationRadians: 0.11058406,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 27,
          handsType: 1,
        },
        {
          position: { x: -3.651, y: 6.516 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 27,
          handsType: 2,
        },
        {
          position: { x: -3.58, y: 6.542 },
          rotationRadians: 0.11058406,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 27,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.944, y: 5.824 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 66,
          handsType: 1,
        },
        {
          position: { x: -3.944, y: 5.824 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 66,
          handsType: 2,
        },
        {
          position: { x: -3.944, y: 5.824 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 66,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4, y: 6.55 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 66,
          handsType: 0,
        },
        {
          position: { x: -4, y: 6.55 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 66,
          handsType: 2,
        },
        {
          position: { x: -4, y: 6.55 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 66,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -2.742, y: 6.372 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -2.995, y: 6.168 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -2.995, y: 6.168 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.16, y: 5.99 },
          rotationRadians: -0.55544193,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.16, y: 5.99 },
          rotationRadians: -0.55544193,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 72,
          handsType: 2,
        },
        {
          position: { x: -4.16, y: 5.99 },
          rotationRadians: -0.55544193,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.155001, y: 5.807 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.5, y: 5.74 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.66, y: 6.39 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.97, y: 6.29 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.54, y: 5.12 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.1518207, y: 7.078669 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.264296, y: 5.4985137 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.2498548, y: 7.6681576 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.935125, y: 6.562192 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.767, y: 6.111 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.78, y: 5.29 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_chopsticks: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.272, y: 5.901 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 27,
          handsType: 1,
        },
        {
          position: { x: -3.692, y: 5.937 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 27,
          handsType: 2,
        },
        {
          position: { x: -3.692, y: 5.937 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 27,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.17, y: 5.73 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
        {
          position: { x: -4.17, y: 5.73 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -4.384, y: 5.754 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 73,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.17, y: 5.73 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
        {
          position: { x: -4.17, y: 5.73 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -4.17, y: 5.73 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 73,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -2.9, y: 5.58 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -2.9, y: 5.58 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -2.9, y: 5.58 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.394, y: 5.844 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.125, y: 5.82 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 61,
          handsType: 2,
        },
        {
          position: { x: -4.394, y: 5.844 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.05, y: 4.79 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.68, y: 5.33 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.69, y: 5.82 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.96, y: 5.57 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.7250073, y: 4.4523277 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 1.1, y: 1.1 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.139, y: 6.56 },
          rotationRadians: 0.63174218,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.71299, y: 5.286008 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.04566, y: 5.0243263 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_cigar: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.141, y: 6.242 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.335, y: 6.093 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.335, y: 6.093 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 40,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.949, y: 5.486 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
        {
          position: { x: -5.146, y: 5.714 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -5.146, y: 5.714 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 88,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.39, y: 6.33 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
        {
          position: { x: -4.99, y: 6.4 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -4.39, y: 6.41 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 71,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.64, y: 5.99 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.56, y: 5.61 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 67,
          handsType: 2,
        },
        {
          position: { x: -3.19, y: 6.13 },
          rotationRadians: -0.2302252,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.03, y: 5.75 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -5.03, y: 5.75 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -5.03, y: 5.75 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.49, y: 5.27 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.3, y: 5.16 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.17, y: 6.11 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.68, y: 5.88 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.3141103, y: 4.9290204 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.8796597, y: 6.669062 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.1849566, y: 4.966486 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.9581425, y: 5.7752457 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.8475199, y: 7.576401 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.491, y: 6.32 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.3211813, y: 5.4437575 },
          rotationRadians: 0.48633074,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.643359, y: 5.047429 },
          rotationRadians: 0.11057562,
          scale: { x: 0.55, y: 0.55 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_climbingRope: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.633, y: 4.7 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 27,
          handsType: 0,
        },
        {
          position: { x: -3.839, y: 4.333 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 27,
          handsType: 2,
        },
        {
          position: { x: -3.078, y: 4.675 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 37,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.6, y: 4.73 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 80,
          handsType: 0,
        },
        {
          position: { x: -4.74, y: 4.62 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 2,
        },
        {
          position: { x: -3.714, y: 4.718 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.24, y: 5 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 2,
        },
        {
          position: { x: -4.05, y: 5.63 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
        {
          position: { x: -4.12, y: 5.57 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.16, y: 4.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.42, y: 4.69 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -3.16, y: 4.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.2, y: 4.2 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 74,
          handsType: 2,
        },
        {
          position: { x: -4.2, y: 4.2 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
        {
          position: { x: -4.82, y: 4.98 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 70,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.35, y: 4.81 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.38, y: 4.67 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.09, y: 5.25 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.65, y: 5.02 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.31, y: 4.04 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.7693324, y: 4.992202 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.85, y: 3.56 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.5788, y: 4.8833027 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.7516396, y: 6.1745763 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.349, y: 5.516 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.924386, y: 4.4399967 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2186403, y: 4.441861 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_coffeeCup: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.23, y: 6.08 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.23, y: 6.08 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.23, y: 6.08 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 38,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.442, y: 5.939 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
        {
          position: { x: -4.85, y: 5.93 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 75,
          handsType: 2,
        },
        {
          position: { x: -4.85, y: 5.93 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 96,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.34, y: 6.39 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 75,
          handsType: 1,
        },
        {
          position: { x: -4.59, y: 6.53 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 75,
          handsType: 2,
        },
        {
          position: { x: -4.59, y: 6.53 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.09, y: 6.53 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.41, y: 5.96 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.21, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.15, y: 6.25 },
          rotationRadians: -0.94672996,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.98, y: 6.09 },
          rotationRadians: -0.94672996,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 64,
          handsType: 2,
        },
        {
          position: { x: -4.15, y: 6.25 },
          rotationRadians: -0.94672996,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.380001, y: 5.75 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.98, y: 5.87 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 6.43 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.16, y: 5.52 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.5940375, y: 6.9836946 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.8596897, y: 6.178954 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.339, y: 6.723 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.2348876, y: 5.9677005 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.3, y: 5.28 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_cookie: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.752, y: 6.064 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.93, y: 5.77 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.93, y: 5.77 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 38,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.17, y: 5.73 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 84,
          handsType: 1,
        },
        {
          position: { x: -4.17, y: 5.73 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
        {
          position: { x: -4.292, y: 5.412 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 74,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.307, y: 6.431 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 74,
          handsType: 1,
        },
        {
          position: { x: -4.307, y: 6.431 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 74,
          handsType: 2,
        },
        {
          position: { x: -4.307, y: 6.431 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.95, y: 5.98 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -2.95, y: 5.98 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.21, y: 5.64 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.49, y: 6.16 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.07, y: 5.55 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 61,
          handsType: 2,
        },
        {
          position: { x: -4.07, y: 5.55 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.24, y: 5.36 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.68, y: 5.33 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.27, y: 5.98 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 4.92 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.478895, y: 4.9215274 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.4747937, y: 7.5496707 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.004, y: 6.426 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.9096503, y: 5.702553 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.15, y: 5.01 },
          rotationRadians: 0.11057562,
          scale: { x: 0.66, y: 0.66 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_cookingSpoon: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.29, y: 5.28 },
          rotationRadians: 2.9664593,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 27,
          handsType: 2,
        },
        {
          position: { x: -3.29, y: 5.28 },
          rotationRadians: 2.9664593,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 27,
          handsType: 1,
        },
        {
          position: { x: -3.29, y: 5.28 },
          rotationRadians: 2.9664593,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 27,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.111, y: 4.806 },
          rotationRadians: -3.6372516,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 72,
          handsType: 1,
        },
        {
          position: { x: -4.111, y: 4.806 },
          rotationRadians: -3.6372516,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 72,
          handsType: 2,
        },
        {
          position: { x: -4.111, y: 4.806 },
          rotationRadians: -3.6372516,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.68, y: 5.94 },
          rotationRadians: -3.7331003,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 72,
          handsType: 2,
        },
        {
          position: { x: -3.68, y: 5.94 },
          rotationRadians: -3.7331003,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 72,
          handsType: 1,
        },
        {
          position: { x: -3.68, y: 5.94 },
          rotationRadians: -3.7331003,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.99, y: 5.06 },
          rotationRadians: -3.5834037,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -2.72, y: 5.46 },
          rotationRadians: -3.5834037,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -2.72, y: 5.25 },
          rotationRadians: -3.5834037,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.333, y: 5.355 },
          rotationRadians: -3.5902076,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.333, y: 5.355 },
          rotationRadians: -3.5902076,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.333, y: 5.355 },
          rotationRadians: -3.5902076,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.04, y: 4.74 },
          rotationRadians: -3.7043179,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.85, y: 4.38 },
          rotationRadians: -3.8165609,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.87, y: 5.61 },
          rotationRadians: -3.9893227,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.27, y: 5.21 },
          rotationRadians: -3.9223105,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 4.54 },
          rotationRadians: -3.763787,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.1767726, y: 6.59 },
          rotationRadians: -3.7498165,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.5200005, y: 4.23 },
          rotationRadians: -3.6880662,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588013, y: 6.0393 },
          rotationRadians: -3.3708819,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.59, y: 6.9 },
          rotationRadians: -3.8128754,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.943, y: 5.728 },
          rotationRadians: 2.9664593,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.61, y: 5.17 },
          rotationRadians: -3.4739003,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4, y: 4.5 },
          rotationRadians: -3.7197736,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_creditCard: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.917, y: 5.857 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.992, y: 5.766 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.066, y: 5.849 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 38,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.232, y: 5.559 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
        {
          position: { x: -4.34, y: 5.35 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -4.232, y: 5.559 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 88,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.678, y: 6.269 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -4.27, y: 6.38 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
        {
          position: { x: -4.678, y: 6.269 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.18, y: 5.98 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.37, y: 5.44 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.17, y: 6.02 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.24, y: 5.76 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 64,
          handsType: 2,
        },
        {
          position: { x: -4.24, y: 5.76 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
        {
          position: { x: -4.31, y: 6.21 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 64,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.26, y: 5.35 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.87, y: 5.42 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.93, y: 6.34 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 6.43 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.644843, y: 6.727096 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.5555634, y: 7.7873588 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.048, y: 6.481 },
          rotationRadians: -0.86944693,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.1289954, y: 5.8223805 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.18, y: 5.08 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_cup: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.244, y: 5.34 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.244, y: 5.34 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.244, y: 5.34 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 35,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.95, y: 4.94 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 78,
          handsType: 0,
        },
        {
          position: { x: -4.84, y: 5 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 66,
          handsType: 2,
        },
        {
          position: { x: -4.95, y: 4.64 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 78,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.95, y: 5.58 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -4.38, y: 6 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
        {
          position: { x: -4.3, y: 6 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.316, y: 5.666 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.564, y: 5.306 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.564, y: 5.306 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.79, y: 6.18 },
          rotationRadians: -0.41282683,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.79, y: 5.26 },
          rotationRadians: 0.40615547,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 61,
          handsType: 2,
        },
        {
          position: { x: -3.79, y: 5.26 },
          rotationRadians: 0.40615547,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.380001, y: 5.11 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.14, y: 4.96 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.16, y: 5.88 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.69 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.06, y: 4.76 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.7284894, y: 6.100076 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.0030394, y: 4.4656777 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.944205, y: 5.8311214 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.7523665, y: 7.021027 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.655, y: 6.069 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 89,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.2429905, y: 5.318039 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.44, y: 4.81 },
          rotationRadians: 0.11057562,
          scale: { x: 0.66, y: 0.66 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_drill: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.706, y: 6.353 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.706, y: 6.353 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.497, y: 6.666 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.18, y: 6.13 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 72,
          handsType: 1,
        },
        {
          position: { x: -5.29, y: 5.97 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 72,
          handsType: 2,
        },
        {
          position: { x: -5.3, y: 5.94 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.79, y: 6.8 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 1,
        },
        {
          position: { x: -5.24, y: 6.71 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 2,
        },
        {
          position: { x: -4.79, y: 6.8 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.87, y: 5.98 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.87, y: 5.98 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.87, y: 5.98 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.2, y: 5.36 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.78, y: 5.04 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -5.57, y: 6.42 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.83, y: 5.85 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.58, y: 5.74 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.34, y: 6.6 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.79, y: 6.53 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.4271145, y: 5.810551 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.064958, y: 7.093777 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.32, y: 5.47 },
          rotationRadians: 0.11057562,
          scale: { x: 1.1, y: 1.1 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.2415328, y: 6.183376 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.42, y: 7.89 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.067, y: 6.694 },
          rotationRadians: 0.25464772,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.52, y: 6.17 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.786196, y: 5.380894 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_elementalControl: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.685, y: 5.694 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 39,
          handsType: 1,
        },
        {
          position: { x: -3.912, y: 5.561 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.912, y: 5.561 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.187, y: 5.618 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 88,
          handsType: 2,
        },
        {
          position: { x: -4.146, y: 5.64 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 92,
          handsType: 0,
        },
        {
          position: { x: -4.392, y: 5.64 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 83,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.97, y: 6.51 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 80,
          handsType: 2,
        },
        {
          position: { x: -4.32, y: 6.41 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 80,
          handsType: 0,
        },
        {
          position: { x: -4.17, y: 6.56 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 80,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -2.79, y: 6.18 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 87,
          handsType: 1,
        },
        {
          position: { x: -2.79, y: 6.18 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
        {
          position: { x: -2.94, y: 5.8 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 99,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.339, y: 5.844 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 87,
          handsType: 2,
        },
        {
          position: { x: -4.339, y: 5.844 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
        {
          position: { x: -4.339, y: 5.844 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 87,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.111, y: 5.41 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 109,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.68, y: 5.33 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 90,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 6.43 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 91,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 91,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.048, y: 6.481 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.1634455, y: 5.6262627 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 111,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.78, y: 5.29 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 98,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_fireSword: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -5.15, y: 8.67 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
        {
          position: { x: -5.15, y: 8.67 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -5.15, y: 8.67 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.45, y: 7.77 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 69,
          handsType: 2,
        },
        {
          position: { x: -5.6, y: 8.17 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
        {
          position: { x: -5.6, y: 8.17 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 69,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.21, y: 8.4 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 69,
          handsType: 2,
        },
        {
          position: { x: -5.21, y: 8.4 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
        {
          position: { x: -5.21, y: 8.4 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 69,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.01, y: 8.22 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.14, y: 7.85 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.79, y: 8.24 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.4, y: 9.07 },
          rotationRadians: -0.40368966,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.81, y: 7.23 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.81, y: 8.29 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.44, y: 8.08 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.86, y: 8.23 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.5890145, y: 7.2614517 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.6354117, y: 9.03226 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.664015, y: 7.399707 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.2455282, y: 7.4487305 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.4755692, y: 9.745281 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.204155, y: 8.37481 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.676484, y: 7.5380926 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.8238363, y: 6.841815 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_fireball: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.31, y: 6.4 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.31, y: 5.88 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.31, y: 5.88 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 38,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.68, y: 6.105 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.921, y: 5.829 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.921, y: 5.829 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 102,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.91, y: 6.61 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.91, y: 6.61 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.91, y: 6.61 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.23, y: 6.36 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.66, y: 5.96 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.48, y: 6.36 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.779, y: 5.856 },
          rotationRadians: -1.0114839,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.224, y: 5.856 },
          rotationRadians: -1.0114839,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 66,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.36, y: 5.48 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 76,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.68, y: 5.33 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.11, y: 6.38 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 6.43 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.280307, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.155, y: 6.118 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.2702117, y: 5.923041 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.435849, y: 5.29 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_fishingRod: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.404, y: 7.559 },
          rotationRadians: 0.11057562,
          scale: { x: 0.75, y: 0.75 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.404, y: 7.559 },
          rotationRadians: 0.11057562,
          scale: { x: 0.75, y: 0.75 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.404, y: 7.559 },
          rotationRadians: 0.11057562,
          scale: { x: 0.75, y: 0.75 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.83, y: 7.15 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 78,
          handsType: 0,
        },
        {
          position: { x: -4.83, y: 7.15 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 76,
          handsType: 2,
        },
        {
          position: { x: -4.83, y: 7.15 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 78,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.73, y: 8.45 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 78,
          handsType: 1,
        },
        {
          position: { x: -5.02, y: 7.77 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 70,
          handsType: 2,
        },
        {
          position: { x: -4.64, y: 8.31 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 78,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9294, y: 8.7351 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.62845814 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.9294, y: 8.7351 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.62845814 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.9294, y: 8.7351 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.62845814 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.61, y: 8.78 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.635489 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -5.85, y: 9.2 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.63548905 },
          spriteLayerNumber: 91,
          handsType: 2,
        },
        {
          position: { x: -5.85, y: 9.2 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.63548905 },
          spriteLayerNumber: 85,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.7, y: 8.2 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.69, y: 9.88 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.43, y: 9.47 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.87, y: 9.67 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.829993, y: 8.51 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.6291356, y: 10.635771 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.7653904, y: 8.434106 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.6359673, y: 8.596675 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2380385, y: 10.517355 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.344, y: 9.243 },
          rotationRadians: 0.12509883,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.8824587, y: 8.936326 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.15, y: 8.07 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_flashlight: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.117, y: 7.046 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.251, y: 6.897 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.109, y: 7.18 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.884, y: 6.744 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 64,
          handsType: 1,
        },
        {
          position: { x: -4.884, y: 6.744 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 64,
          handsType: 2,
        },
        {
          position: { x: -4.884, y: 6.744 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 79,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.53, y: 6.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 1,
        },
        {
          position: { x: -4.53, y: 6.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -4.53, y: 6.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.372, y: 6.212 },
          rotationRadians: 0.11058406,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.081, y: 6.745 },
          rotationRadians: 0.11058406,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.081, y: 6.745 },
          rotationRadians: 0.11058406,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.68, y: 5.27 },
          rotationRadians: -4.2768173,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.46, y: 5.24 },
          rotationRadians: 2.09078,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 63,
          handsType: 2,
        },
        {
          position: { x: -4.46, y: 5.24 },
          rotationRadians: 2.09078,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 80,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.351, y: 5.892 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.99, y: 6.05 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.07, y: 6.76 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 6.43 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.983895 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 80,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 80,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.8097086, y: 6.3955894 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.943808 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.234, y: 6.849 },
          rotationRadians: 0,
          scale: { x: 0.55, y: 0.55 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.0124545, y: 6.323144 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.1467686, y: 5.4822354 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_flowers: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.47, y: 7.29 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.57, y: 6.89 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.43, y: 7.47 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.03, y: 6.949 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 78,
          handsType: 1,
        },
        {
          position: { x: -5.03, y: 6.949 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -5.03, y: 6.949 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.167, y: 7.932 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
        {
          position: { x: -5.167, y: 7.932 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -5.167, y: 7.932 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 71,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.47, y: 7.1 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.74, y: 6.69 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.48, y: 7.31 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.7437873, y: 7.314765 },
          rotationRadians: 0.23425694,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -5.1215954, y: 5.142838 },
          rotationRadians: 1.6340448,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -5.1215954, y: 5.142838 },
          rotationRadians: 1.6340448,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.592, y: 6.345 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.26, y: 6.64 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.19, y: 7.15 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.71, y: 7.3 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.284494, y: 6.1170588 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.138938, y: 8.0461035 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.147439, y: 6.310334 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.1284437, y: 6.7009406 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.058186, y: 8.640121 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.728538, y: 7.367969 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.518561, y: 6.771906 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.4498687, y: 5.695671 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_football: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.2, y: 5.71 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 35,
          handsType: 1,
        },
        {
          position: { x: -4.2, y: 5.71 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 25,
          handsType: 2,
        },
        {
          position: { x: -4.2, y: 5.71 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 25,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.28, y: 5.35 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
        {
          position: { x: -4.6, y: 5.29 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 69,
          handsType: 2,
        },
        {
          position: { x: -4.6, y: 5.29 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 84,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.48, y: 6.45 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 69,
          handsType: 1,
        },
        {
          position: { x: -4.59, y: 6.08 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 69,
          handsType: 2,
        },
        {
          position: { x: -4.48, y: 6.45 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.182, y: 5.845 },
          rotationRadians: 0.11057562,
          scale: { x: 0.75, y: 0.75 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.505, y: 5.802 },
          rotationRadians: 0.11057562,
          scale: { x: 0.75, y: 0.75 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.505, y: 5.802 },
          rotationRadians: 0.11057562,
          scale: { x: 0.75, y: 0.75 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.3, y: 5.62 },
          rotationRadians: -1.1419124,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.98, y: 5.3 },
          rotationRadians: -1.1419124,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.81, y: 5.92 },
          rotationRadians: -1.1419124,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.28, y: 5.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.85, y: 5.31 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 6.43 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.990843, y: 5.059765 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.588467, y: 6.342856 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.8095179, y: 6.303787 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.575, y: 6.198 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 94,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.1487827, y: 5.7322903 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2362337, y: 5.090167 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_fork: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.26, y: 6.83 },
          rotationRadians: 0.24134599,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 26,
          handsType: 1,
        },
        {
          position: { x: -4.26, y: 6.83 },
          rotationRadians: 0.24134599,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 26,
          handsType: 2,
        },
        {
          position: { x: -4.26, y: 6.83 },
          rotationRadians: 0.24134599,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 26,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.497, y: 6.423 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 79,
          handsType: 1,
        },
        {
          position: { x: -4.497, y: 6.423 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 67,
          handsType: 2,
        },
        {
          position: { x: -4.598, y: 6.524 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.307, y: 7.307 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 67,
          handsType: 1,
        },
        {
          position: { x: -4.307, y: 7.307 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 67,
          handsType: 2,
        },
        {
          position: { x: -4.307, y: 7.307 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.1899986, y: 6.92 },
          rotationRadians: 0.15288761,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.24, y: 6.45 },
          rotationRadians: 0.15288761,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 62,
          handsType: 2,
        },
        {
          position: { x: -3.06, y: 6.64 },
          rotationRadians: 0.15288761,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.11, y: 6.73 },
          rotationRadians: -0.50466802,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.2, y: 6.9 },
          rotationRadians: -0.50466802,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 62,
          handsType: 2,
        },
        {
          position: { x: -4.2, y: 6.9 },
          rotationRadians: -0.50466802,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 80,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.189, y: 5.814 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.87, y: 6.33 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.97, y: 7.03 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.22, y: 6.86 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.5136843, y: 7.3682275 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 80,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.745293, y: 5.716989 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 80,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.7085524, y: 6.475743 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.6247134, y: 8.332994 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.156, y: 7.065 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.1041126, y: 6.457364 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.257387, y: 5.72338 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_globe: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.1299996, y: 5.24 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.1299996, y: 5.24 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.1299996, y: 5.24 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 43,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.99, y: 6.93 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 80,
          handsType: 0,
        },
        {
          position: { x: -4.99, y: 6.93 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 70,
          handsType: 2,
        },
        {
          position: { x: -4.99, y: 6.93 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 102,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.79, y: 7.17 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 80,
          handsType: 1,
        },
        {
          position: { x: -4.79, y: 7.17 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 70,
          handsType: 2,
        },
        {
          position: { x: -4.79, y: 7.17 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.365, y: 6.893 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.494, y: 6.871 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.302, y: 6.918 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.15, y: 5.33 },
          rotationRadians: 1.8593034,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.88, y: 5.28 },
          rotationRadians: 1.8593034,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -5.15, y: 5.33 },
          rotationRadians: 1.8593034,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.380001, y: 5.75 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.04, y: 6.57 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.15, y: 6.48 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.54, y: 6.67 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.7941093, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.8173904, y: 4.7159433 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.0650456, y: 6.312456 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9101734, y: 7.9435754 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.938, y: 7.256 },
          rotationRadians: 0.23542335,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.382887, y: 6.389831 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.4481196, y: 5.6131806 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_goldCoin: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.901, y: 5.801 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.901, y: 5.801 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.901, y: 5.801 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 42,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.54, y: 5.27 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 79,
          handsType: 0,
        },
        {
          position: { x: -4.54, y: 5.27 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 66,
          handsType: 2,
        },
        {
          position: { x: -4.54, y: 5.27 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 83,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.44, y: 6.12 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.44, y: 6.12 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -4.44, y: 6.12 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.72, y: 6.2 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -2.98, y: 5.56 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.41, y: 6.03 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.1, y: 5.55 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.04, y: 5.48 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.168, y: 5.339 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.68, y: 5.33 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.24, y: 6.23 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.087, y: 6.452 },
          rotationRadians: 0,
          scale: { x: 0.55, y: 0.55 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.9508023, y: 5.889964 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.0533357, y: 4.973734 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_hammer: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.83, y: 7.68 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 27,
          handsType: 0,
        },
        {
          position: { x: -4.83, y: 7.68 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 27,
          handsType: 1,
        },
        {
          position: { x: -4.83, y: 7.68 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 27,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -5.69, y: 7.49 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -5.73, y: 7.4 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -5.72, y: 7.63 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.98, y: 7.69 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.98, y: 7.69 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.98, y: 7.69 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.87, y: 7.21 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.14, y: 7.06 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.87, y: 7.4 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.91, y: 7.82 },
          rotationRadians: -0.31746076,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.91, y: 7.82 },
          rotationRadians: -0.31746076,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.91, y: 7.82 },
          rotationRadians: -0.31746076,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.69, y: 6.5 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.5, y: 7.1 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.53, y: 7.51 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.99, y: 7.57 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.45, y: 6.25 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.3059874, y: 8.067669 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.6740165, y: 6.6128273 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.1852002, y: 6.927915 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.439492, y: 8.734706 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.779, y: 7.622 },
          rotationRadians: -0.13119246,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.0712347, y: 7.233714 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.01, y: 6.34 },
          rotationRadians: 0.11057562,
          scale: { x: 0.66, y: 0.66 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_hardLight: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -0.07, y: 7.88 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 27,
          handsType: 2,
        },
        {
          position: { x: -0.07, y: 7.88 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 27,
          handsType: 0,
        },
        {
          position: { x: -0.07, y: 7.88 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 37,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -0.56, y: 7.71 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 80,
          handsType: 1,
        },
        {
          position: { x: -0.56, y: 7.71 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 80,
          handsType: 2,
        },
        {
          position: { x: -0.56, y: 7.71 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 80,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.81, y: 8.73 },
          rotationRadians: 0.11057562,
          scale: { x: 0.85, y: 0.85 },
          spriteLayerNumber: 80,
          handsType: 0,
        },
        {
          position: { x: -0.81, y: 8.73 },
          rotationRadians: 0.11057562,
          scale: { x: 0.85, y: 0.85 },
          spriteLayerNumber: 80,
          handsType: 2,
        },
        {
          position: { x: -0.81, y: 8.73 },
          rotationRadians: 0.11057562,
          scale: { x: 0.85, y: 0.85 },
          spriteLayerNumber: 80,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: 0.02, y: 8.3 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 89,
          handsType: 0,
        },
        {
          position: { x: 0.02, y: 8.3 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 89,
          handsType: 2,
        },
        {
          position: { x: 0.02, y: 8.3 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 89,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -0.98, y: 7.93 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 89,
          handsType: 2,
        },
        {
          position: { x: -1.03, y: 7.64 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 89,
          handsType: 0,
        },
        {
          position: { x: -0.98, y: 7.93 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 89,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -0.74, y: 7.21 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 94,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.99, y: 7.39 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.15, y: 7.96 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.52, y: 8.08 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.08373442, y: 7.06903 },
          rotationRadians: 0,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.89, y: 8.64 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 89,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.23, y: 7.13 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 89,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: 0.44, y: 8.63 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8869, y: 1 },
          spriteLayerNumber: 89,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.23, y: 9.84 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 89,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.18, y: 8.079 },
          rotationRadians: 0,
          scale: { x: 0.85, y: 0.85 },
          spriteLayerNumber: 89,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -1.6, y: 7.96 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 94,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -0.5425225, y: 7.367757 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 90,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_healing: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.81, y: 6.33 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 27,
          handsType: 0,
        },
        {
          position: { x: -3.81, y: 6.33 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 27,
          handsType: 2,
        },
        {
          position: { x: -3.64, y: 6.17 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 35,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.17, y: 5.73 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 85,
          handsType: 1,
        },
        {
          position: { x: -4.17, y: 5.73 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 85,
          handsType: 2,
        },
        {
          position: { x: -4.17, y: 5.73 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 85,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.378, y: 6.73 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 85,
          handsType: 0,
        },
        {
          position: { x: -4.378, y: 6.73 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 85,
          handsType: 1,
        },
        {
          position: { x: -4.378, y: 6.73 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 85,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 86,
          handsType: 0,
        },
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 86,
          handsType: 2,
        },
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 86,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.48, y: 6.27 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 86,
          handsType: 1,
        },
        {
          position: { x: -4.48, y: 6.27 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 86,
          handsType: 2,
        },
        {
          position: { x: -4.48, y: 6.27 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 86,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.380001, y: 5.75 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.68, y: 5.33 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.69, y: 6.21 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 89,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.3, y: 6.23 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 89,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.54, y: 5.12 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 89,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 86,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 86,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 86,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 86,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.99, y: 6.64 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 86,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.059, y: 5.823 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 92,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.78, y: 5.29 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 92,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_hockeyStick: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.64, y: 7.598 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
        {
          position: { x: -3.64, y: 7.598 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.64, y: 7.598 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2, y: 7.18 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.2, y: 7.18 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.2, y: 7.18 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.21, y: 8.31 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.21, y: 8.31 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.21, y: 8.31 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.73, y: 9.34 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.03, y: 9.22 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.77, y: 9.39 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.11, y: 7.38 },
          rotationRadians: -0.14398302,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 60,
          handsType: 2,
        },
        {
          position: { x: -4.11, y: 7.38 },
          rotationRadians: -0.14398302,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
        {
          position: { x: -4.11, y: 7.38 },
          rotationRadians: -0.14398302,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 70,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.41, y: 7.6 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.23, y: 8.98 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.65, y: 7.5 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2, y: 8.19 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.299715, y: 7.934301 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 8.438202 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.882639, y: 7.524462 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.9166777, y: 7.2634993 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.7188647, y: 9.406867 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.702915, y: 8.752796 },
          rotationRadians: 0.16581176,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.536843, y: 8.158892 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.7721653, y: 7.5691967 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_iceCreamCone: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.013, y: 7.255 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.116, y: 7.015 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.704, y: 7.169 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.69, y: 6.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 1,
        },
        {
          position: { x: -4.69, y: 6.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 2,
        },
        {
          position: { x: -4.69, y: 6.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.62, y: 7.44 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 1,
        },
        {
          position: { x: -4.62, y: 7.44 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 2,
        },
        {
          position: { x: -4.31, y: 7.47 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.907, y: 6.813 },
          rotationRadians: -0.078885767,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -2.994, y: 6.41 },
          rotationRadians: -0.078885767,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -2.907, y: 6.813 },
          rotationRadians: -0.078885767,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.59, y: 6.57 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.18, y: 5.67 },
          rotationRadians: -0.75176385,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 67,
          handsType: 2,
        },
        {
          position: { x: -4.18, y: 5.67 },
          rotationRadians: -0.75176385,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.189, y: 6.061 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.77, y: 6.34 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.85, y: 6.94 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.28, y: 6.7 },
          rotationRadians: 0.21863961,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.5218577, y: 7.509838 },
          rotationRadians: 0.07758457,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.672512, y: 5.8063946 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.928837, y: 6.4077587 },
          rotationRadians: 0.53043443,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 8.209319 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.326, y: 6.981 },
          rotationRadians: 0.2936649,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.9975624, y: 6.4995985 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2479744, y: 5.603991 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_lacrossStick: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -5.156, y: 9.281 },
          rotationRadians: 0.11057562,
          scale: { x: 0.85, y: 0.85 },
          spriteLayerNumber: 27,
          handsType: 1,
        },
        {
          position: { x: -5.156, y: 9.281 },
          rotationRadians: 0.11057562,
          scale: { x: 0.85, y: 0.85 },
          spriteLayerNumber: 27,
          handsType: 2,
        },
        {
          position: { x: -5.156, y: 9.281 },
          rotationRadians: 0.11057562,
          scale: { x: 0.85, y: 0.85 },
          spriteLayerNumber: 27,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.72, y: 9.14 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
        {
          position: { x: -5.84, y: 8.87 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 75,
          handsType: 2,
        },
        {
          position: { x: -5.8, y: 8.69 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 75,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.83, y: 7.32 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 75,
          handsType: 2,
        },
        {
          position: { x: -4.83, y: 7.32 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
        {
          position: { x: -4.39, y: 7.56 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 75,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.075, y: 8.679 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.338, y: 8.485 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.338, y: 8.485 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.13, y: 7.37 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -5.13, y: 7.37 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -5.13, y: 7.37 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.03, y: 8.01 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 78,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.51, y: 8.23 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.44, y: 8.74 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6679636 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.9300027, y: 8.85 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.65, y: 6.6 },
          rotationRadians: 0.19259028,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.2139583, y: 8.900811 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.4368677, y: 7.218035 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.175104, y: 7.191377 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.709712, y: 10.17924 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.205, y: 8.725 },
          rotationRadians: 0.11057562,
          scale: { x: 0.85, y: 0.85 },
          spriteLayerNumber: 76,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.23, y: 8.618 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.23, y: 7.62 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_laserGun: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.4, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.66, y: 5.99 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.61, y: 6.23 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.26, y: 5.907 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -5.43, y: 5.666 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -5.359, y: 5.68 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 88,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.23, y: 6.86 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
        {
          position: { x: -5.44, y: 6.56 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -5, y: 6.89 },
          rotationRadians: 0.11058406,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.874, y: 6.342 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.936, y: 6.094 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.874, y: 6.342 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.39, y: 6.5 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.458, y: 5.52 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.458, y: 5.52 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.557, y: 5.686 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.7, y: 5.81 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.47, y: 6.56 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.08, y: 6.46 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.6, y: 5.36 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.6792703, y: 6.980192 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.4389443, y: 5.1435704 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.2741978, y: 6.1591063 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.334543, y: 7.729872 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.181, y: 7.246 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.611461, y: 5.8150964 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.672073, y: 5.331162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_laserPointer: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.481, y: 6.428 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
        {
          position: { x: -3.481, y: 6.428 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.481, y: 6.428 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.31, y: 6.17 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 76,
          handsType: 0,
        },
        {
          position: { x: -4.31, y: 6.17 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 76,
          handsType: 2,
        },
        {
          position: { x: -4.31, y: 6.17 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 76,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.44, y: 6.75 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 76,
          handsType: 0,
        },
        {
          position: { x: -4.44, y: 6.75 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 69,
          handsType: 2,
        },
        {
          position: { x: -4.44, y: 6.75 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 76,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.21, y: 5.82 },
          rotationRadians: -1.0693449,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 74,
          handsType: 2,
        },
        {
          position: { x: -4.21, y: 5.82 },
          rotationRadians: -1.0693449,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
        {
          position: { x: -4.21, y: 5.82 },
          rotationRadians: -1.0693449,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 74,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.196, y: 5.842 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.75, y: 6.06 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.9, y: 6.81 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.1, y: 6.63 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.085589, y: 6.8645244 },
          rotationRadians: -0.06869967,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.417525, y: 5.360518 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 8.03184 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.048, y: 6.481 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.767, y: 6.111 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.109833, y: 5.4087777 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_levitation: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.013, y: 7.255 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
        {
          position: { x: -4.013, y: 7.255 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.013, y: 7.255 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.658, y: 6.056 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.658, y: 6.056 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.658, y: 6.056 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.52, y: 6.71 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.52, y: 6.71 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.52, y: 6.71 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -2.9424, y: 6.5012 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.58932996 },
          spriteLayerNumber: 98,
          handsType: 1,
        },
        {
          position: { x: -2.9424, y: 6.5012 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.58932996 },
          spriteLayerNumber: 98,
          handsType: 2,
        },
        {
          position: { x: -2.9424, y: 6.5012 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.58932996 },
          spriteLayerNumber: 98,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.7, y: 6.58 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 98,
          handsType: 1,
        },
        {
          position: { x: -4.7, y: 6.58 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 98,
          handsType: 0,
        },
        {
          position: { x: -4.7, y: 6.58 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 98,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.32, y: 5.64 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 108,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.66, y: 5.88 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 62,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 96,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 6.43 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 96,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.6922662, y: 5.5853586 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 96,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 98,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 98,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 98,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 8.106537 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 98,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.220733, y: 6.8104076 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 98,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.9430556, y: 6.111409 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 97,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.941061, y: 5.750394 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 103,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_lightening: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.36, y: 6.32 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.36, y: 6.32 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.17, y: 6.48 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 40,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.02, y: 6.34 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 83,
          handsType: 1,
        },
        {
          position: { x: -4.75, y: 6.45 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 83,
          handsType: 0,
        },
        {
          position: { x: -4.75, y: 6.45 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 72,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.95, y: 7.16 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 83,
          handsType: 0,
        },
        {
          position: { x: -4.69, y: 6.64 },
          rotationRadians: 0.11058406,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -4.49, y: 6.81 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 64,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.274, y: 6.624 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.527, y: 6.457 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.527, y: 6.457 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.045, y: 5.14 },
          rotationRadians: -0.67443673,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.722, y: 4.664 },
          rotationRadians: -0.67443673,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -5.166, y: 5.519 },
          rotationRadians: -0.67443673,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.380001, y: 5.75 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.68, y: 5.33 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 6.43 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.5175, y: 6.9543753 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.012214, y: 6.1993833 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.424768, y: 6.751716 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.767, y: 6.111 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.242449, y: 5.256063 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_magazine: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.531, y: 6.412 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.757, y: 6.191 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.757, y: 6.191 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 35,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.18, y: 5.6 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 78,
          handsType: 0,
        },
        {
          position: { x: -5.18, y: 5.6 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 74,
          handsType: 2,
        },
        {
          position: { x: -5.18, y: 5.6 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 82,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.63, y: 6.65 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 78,
          handsType: 1,
        },
        {
          position: { x: -5.04, y: 6.11 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 65,
          handsType: 2,
        },
        {
          position: { x: -5.04, y: 6.11 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 6.1 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 65,
          handsType: 2,
        },
        {
          position: { x: -3.62, y: 6.18 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
        {
          position: { x: -3.7, y: 6.28 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 65,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.69, y: 4.82 },
          rotationRadians: 2.4364742,
          scale: { x: 0.8, y: 0.9 },
          spriteLayerNumber: 75,
          handsType: 2,
        },
        {
          position: { x: -4.69, y: 4.82 },
          rotationRadians: 2.4364742,
          scale: { x: 0.8, y: 0.9 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
        {
          position: { x: -5.15, y: 5.5 },
          rotationRadians: 2.4364742,
          scale: { x: 0.8, y: 0.9 },
          spriteLayerNumber: 75,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.663, y: 5.637 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.38, y: 5.72 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.38, y: 6.51 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.74, y: 6.39 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.37, y: 5.18 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.0597415, y: 6.6451945 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.2662725, y: 4.8060107 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.9870923, y: 5.9615164 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.233428, y: 7.6655703 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.894, y: 6.806 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 120,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.47055, y: 5.896283 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.5764356, y: 5.280364 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_microphone: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.818, y: 6.6 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.818, y: 6.6 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.818, y: 6.6 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 38,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.412, y: 6.31 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 78,
          handsType: 0,
        },
        {
          position: { x: -4.412, y: 6.31 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -4.271, y: 6.355 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 78,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.36, y: 6.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 1,
        },
        {
          position: { x: -4.36, y: 6.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 2,
        },
        {
          position: { x: -4.36, y: 6.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.992, y: 6.492 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.245, y: 6.282 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -2.992, y: 6.492 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.58, y: 5.99 },
          rotationRadians: -1.0266975,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.37, y: 5.69 },
          rotationRadians: -1.0266975,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.58, y: 5.99 },
          rotationRadians: -1.0266975,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.13, y: 5.75 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.7, y: 5.91 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.82, y: 6.63 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.4, y: 6.77 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 7.014172 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.526457 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.5946102, y: 6.127321 },
          rotationRadians: 0.31079934,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.3033888, y: 7.8527074 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.258, y: 6.691 },
          rotationRadians: 0.18620869,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.7531066, y: 5.938538 },
          rotationRadians: 0.32875438,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.07, y: 5.38 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_mobilePhone: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.9, y: 5.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.9, y: 5.97 },
          rotationRadians: 0.11058406,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.9, y: 5.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 39,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.443, y: 5.683 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
        {
          position: { x: -4.443, y: 5.683 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -4.443, y: 5.683 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 87,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.616, y: 6.666 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 1,
        },
        {
          position: { x: -4.616, y: 6.666 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -4.616, y: 6.666 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.29, y: 6.34 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.34, y: 5.9 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.07, y: 6.14 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: -0.1150981,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.01, y: 5.97 },
          rotationRadians: -1.4642286,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 2,
        },
        {
          position: { x: -4.01, y: 5.97 },
          rotationRadians: -1.4642286,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.28, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.85, y: 5.62 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.29, y: 6.26 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.87, y: 5.09 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.495729, y: 5.949114 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.214, y: 6.68 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.9768944, y: 5.7994995 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.25, y: 5.18 },
          rotationRadians: 0.11057562,
          scale: { x: 0.55, y: 0.55 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  'holdingRight_morphing ': {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.117, y: 6.539 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.199, y: 6.174 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.199, y: 6.174 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 43,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.49, y: 5.94 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 85,
          handsType: 1,
        },
        {
          position: { x: -4.41, y: 6.12 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 84,
          handsType: 2,
        },
        {
          position: { x: -4.29, y: 5.87 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 85,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.64, y: 6.56 },
          rotationRadians: -0.51634216,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 79,
          handsType: 2,
        },
        {
          position: { x: -3.64, y: 6.56 },
          rotationRadians: -0.51634216,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 79,
          handsType: 1,
        },
        {
          position: { x: -3.64, y: 6.56 },
          rotationRadians: -0.51634216,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 79,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.79, y: 6.31 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 80,
          handsType: 2,
        },
        {
          position: { x: -2.79, y: 6.31 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 88,
          handsType: 0,
        },
        {
          position: { x: -2.79, y: 6.31 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 84,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 88,
          handsType: 1,
        },
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 88,
          handsType: 2,
        },
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 88,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.076, y: 5.672 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 102,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.68, y: 5.7 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 66,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.79, y: 6.44 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 93,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.34, y: 6.75 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 93,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 93,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 88,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.3944235 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 88,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.639923, y: 6.251069 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 88,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 8.056794 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 88,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.369, y: 6.774 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 88,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.9358945, y: 5.9940367 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 114,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.78, y: 5.29 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 100,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_paintBrush: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.318, y: 5 },
          rotationRadians: 2.8513081,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.318, y: 5 },
          rotationRadians: 2.8513081,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.235, y: 5.025 },
          rotationRadians: 2.8513081,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.93, y: 4.77 },
          rotationRadians: -3.4963712,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
        {
          position: { x: -4.14, y: 4.57 },
          rotationRadians: -3.4963712,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.14, y: 4.57 },
          rotationRadians: -3.4963712,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.46, y: 5.71 },
          rotationRadians: -3.526009,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
        {
          position: { x: -3.46, y: 5.71 },
          rotationRadians: -3.526009,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -3.46, y: 5.71 },
          rotationRadians: -3.526009,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.603, y: 5.548 },
          rotationRadians: -3.8849399,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -2.808, y: 5.089 },
          rotationRadians: -3.6758125,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -2.78, y: 5.523 },
          rotationRadians: -3.6758125,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.151, y: 5.214 },
          rotationRadians: -3.909668,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 61,
          handsType: 2,
        },
        {
          position: { x: -4.151, y: 5.214 },
          rotationRadians: -3.909668,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
        {
          position: { x: -4.151, y: 5.214 },
          rotationRadians: -3.909668,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 72,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.98, y: 4.84 },
          rotationRadians: -3.6792062,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.45, y: 4.31 },
          rotationRadians: -3.6630688,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.75, y: 5.5 },
          rotationRadians: -3.9403669,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.16, y: 5.99 },
          rotationRadians: -3.9293771,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.45, y: 4.49 },
          rotationRadians: -3.6657094,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.04, y: 6.57 },
          rotationRadians: -3.9396014,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.21, y: 4.44 },
          rotationRadians: -3.7646072,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588013, y: 6.0393 },
          rotationRadians: -3.241548,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.33, y: 6.99 },
          rotationRadians: -3.8325306,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.804, y: 5.369 },
          rotationRadians: -3.5313497,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.54, y: 5.45 },
          rotationRadians: -3.5889497,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.73, y: 4.78 },
          rotationRadians: -3.4931699,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_paintCan: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.413, y: 4.733 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 27,
          handsType: 0,
        },
        {
          position: { x: -3.591, y: 4.436 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 27,
          handsType: 2,
        },
        {
          position: { x: -3.76, y: 4.76 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 27,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.17, y: 4.27 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.474, y: 5.1 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.432, y: 5.206 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 84,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.22, y: 5.3 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
        {
          position: { x: -4.28, y: 5.26 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.28, y: 5.26 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.962, y: 4.922 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -2.962, y: 4.922 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -2.962, y: 4.922 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.23, y: 4.56 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.23, y: 4.56 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.844, y: 4.158 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.17, y: 4.69 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.8, y: 4.23 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.8, y: 5.45 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.22, y: 5.14 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.88, y: 4.23 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.1369, y: 5.2737 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 1.0053899 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.68, y: 3.39 },
          rotationRadians: 0.11057562,
          scale: { x: 1.2, y: 1.2 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.5690253, y: 5.4336705 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.218, y: 5.996 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.96744007 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.502, y: 5.195 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.72104496 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.7643, y: 4.5353 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.86332995 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.0316, y: 4.3242 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.72618 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_passport: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.752, y: 6.064 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.868, y: 5.937 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.868, y: 5.937 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 37,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.326, y: 5.588 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.326, y: 5.588 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.326, y: 5.588 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 85,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.44, y: 6.54 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.44, y: 6.54 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.44, y: 6.54 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.34, y: 5.88 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 65,
          handsType: 2,
        },
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.14, y: 5.57 },
          rotationRadians: -1.3306879,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 67,
          handsType: 2,
        },
        {
          position: { x: -4.14, y: 5.57 },
          rotationRadians: -1.3306879,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.316, y: 5.418 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.02, y: 5.48 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.24, y: 5.99 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.579796, y: 6.6198225 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 1.1, y: 1.1 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.8897243, y: 6.1882033 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.395, y: 6.908 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.915715, y: 5.6733904 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.332123, y: 5.2404923 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_pen: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.284, y: 5.82 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.392, y: 5.795 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.284, y: 5.82 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.021, y: 5.737 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.021, y: 5.737 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.021, y: 5.737 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.4, y: 6.22 },
          rotationRadians: 0.11058406,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.8, y: 6.04 },
          rotationRadians: 0.11058406,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -3.4, y: 6.22 },
          rotationRadians: 0.11058406,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -2.72, y: 5.46 },
          rotationRadians: -0.027320293,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 67,
          handsType: 2,
        },
        {
          position: { x: -2.72, y: 5.46 },
          rotationRadians: -0.027320293,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
        {
          position: { x: -2.72, y: 5.46 },
          rotationRadians: -0.027320293,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 67,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.2, y: 5.92 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
        {
          position: { x: -4.2, y: 5.92 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 2,
        },
        {
          position: { x: -4.2, y: 5.92 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.86, y: 5.07 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.37, y: 5.5 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.63, y: 5.72 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.74, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.56, y: 5.02 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.0421505, y: 6.5277367 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2917953, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.2615335, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9700012, y: 6.286 },
          rotationRadians: 0.11927189,
          scale: { x: 0.55, y: 0.55 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.767, y: 6.111 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9010339, y: 5.211505 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_poolCue: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.66, y: 7.54 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
        {
          position: { x: -3.66, y: 7.54 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.66, y: 7.54 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.68, y: 7.95 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.68, y: 7.95 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.68, y: 7.95 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.42, y: 6.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.42, y: 6.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
        {
          position: { x: -4.08, y: 8.09 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.67, y: 9.37 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.74392 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.93, y: 9.23 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.74392 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.67, y: 9.37 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.74392 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.67, y: 8.67 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.67, y: 8.67 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.67, y: 8.67 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.33, y: 7.703 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4, y: 9.1 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.9, y: 8.44 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.26, y: 8.92 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.03, y: 7.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.327327, y: 8.124616 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.538857, y: 6.502421 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.1845288, y: 7.999615 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.3303468, y: 8.656325 },
          rotationRadians: -0.011081602,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.174, y: 7.296 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.175282, y: 7.803231 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.4813175, y: 6.64562 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_present: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.93, y: 5.38 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 27,
          handsType: 0,
        },
        {
          position: { x: -4.18, y: 5.04 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 27,
          handsType: 2,
        },
        {
          position: { x: -3.93, y: 5.38 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 37,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.768, y: 4.906 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 66,
          handsType: 0,
        },
        {
          position: { x: -4.768, y: 4.877 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 66,
          handsType: 2,
        },
        {
          position: { x: -4.768, y: 4.906 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 87,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.7, y: 6.07 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 66,
          handsType: 1,
        },
        {
          position: { x: -4.76, y: 5.65 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 66,
          handsType: 2,
        },
        {
          position: { x: -4.54, y: 6.18 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 66,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.915, y: 5.689 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.006, y: 5.124 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.915, y: 5.689 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.29, y: 6.23 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.86, y: 5.09 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.86, y: 5.09 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.37, y: 5 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 5.01 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.62, y: 5.95 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.753828, y: 5.66 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.67, y: 4.92 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.364129, y: 6.0345654 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.644254, y: 4.302204 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.6902103, y: 5.498393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.374367, y: 7.2884054 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.718, y: 5.99 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.5 },
          spriteLayerNumber: 95,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.240183, y: 5.3308806 },
          rotationRadians: 0.11057562,
          scale: { x: 0.75, y: 0.75 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.75, y: 4.58 },
          rotationRadians: 0.11057562,
          scale: { x: 0.66, y: 0.66 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_prophecy: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.81, y: 6.33 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 27,
          handsType: 1,
        },
        {
          position: { x: -3.81, y: 6.33 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 27,
          handsType: 2,
        },
        {
          position: { x: -3.81, y: 6.33 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 27,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.426, y: 5.917 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 85,
          handsType: 0,
        },
        {
          position: { x: -4.17, y: 5.73 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 85,
          handsType: 1,
        },
        {
          position: { x: -4.308, y: 5.956 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 85,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.378, y: 6.73 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 85,
          handsType: 0,
        },
        {
          position: { x: -3.83, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 85,
          handsType: 2,
        },
        {
          position: { x: -4.02, y: 6.57 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 85,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -2.768, y: 6.291 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 83,
          handsType: 1,
        },
        {
          position: { x: -2.768, y: 6.291 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 83,
          handsType: 2,
        },
        {
          position: { x: -2.768, y: 6.291 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 83,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 83,
          handsType: 0,
        },
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 83,
          handsType: 1,
        },
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 83,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.17, y: 5.42 },
          rotationRadians: 0,
          scale: { x: 0.4, y: 0.4 },
          spriteLayerNumber: 165,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.68, y: 5.33 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 165,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.69, y: 6.21 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 100,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.3, y: 6.26 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 100,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.63, y: 5.1 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 100,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 83,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 94,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.4, y: 0.4 },
          spriteLayerNumber: 94,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 83,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.99, y: 6.64 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 83,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.132, y: 5.607 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.6 },
          spriteLayerNumber: 85,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.78, y: 5.29 },
          rotationRadians: 0.11057562,
          scale: { x: 0.45, y: 0.45 },
          spriteLayerNumber: 86,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_purse1: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.075, y: 4.705 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.075, y: 4.705 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.075, y: 4.705 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 45,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.772, y: 4.687 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 79,
          handsType: 0,
        },
        {
          position: { x: -4.772, y: 4.687 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 67,
          handsType: 2,
        },
        {
          position: { x: -4.772, y: 4.687 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 67,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.696, y: 5.808 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 70,
          handsType: 1,
        },
        {
          position: { x: -4.22, y: 4.96 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 2,
        },
        {
          position: { x: -3.92, y: 5.3 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.39, y: 5.18 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.39, y: 5.18 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.39, y: 5.18 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.486, y: 4.439 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.486, y: 4.439 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.987, y: 4.793 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.21, y: 4.802 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.23, y: 4.87 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.05, y: 5.61 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.4, y: 5.34 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.12, y: 4.27 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.5227866, y: 5.623117 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.651038, y: 4.040117 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.646123, y: 5.375483 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 6.599601 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.364275, y: 5.551182 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.005139, y: 5.0128117 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2699676, y: 4.5283914 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_purse2: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.001, y: 4.356 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.001, y: 4.356 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.001, y: 4.356 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 1 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.85, y: 4.31 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.91, y: 4.21 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.97, y: 4.01 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.04, y: 5.34 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
        {
          position: { x: -4.19, y: 5.11 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.75, y: 6.13 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.58, y: 5.07 },
          rotationRadians: -0.070038462,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.58, y: 5.07 },
          rotationRadians: -0.070038462,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.58, y: 5.07 },
          rotationRadians: -0.070038462,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.161, y: 4.787 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.683, y: 4.114 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -5.161, y: 4.787 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.39, y: 4.52 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.24, y: 4.41 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.13, y: 5.42 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.55, y: 5.18 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.155864, y: 4.2105803 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.693475, y: 5.44551 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 3.664083 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.6555293, y: 5.1139836 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.66504, y: 6.5161386 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.4517508, y: 5.1163573 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.0125084, y: 4.815156 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.4766226, y: 4.2036924 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_purse3: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.681, y: 4.153 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
        {
          position: { x: -3.764, y: 4.153 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.764, y: 4.153 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.56, y: 4.1 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.71, y: 3.88 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.69, y: 4.16 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4, y: 5.12 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
        {
          position: { x: -4.26, y: 4.83 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -3.88, y: 5.14 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.29, y: 4.88 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.29, y: 4.88 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.1, y: 5.28 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.974, y: 4.384 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.974, y: 4.384 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.974, y: 4.384 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.338, y: 4.37 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.16, y: 4.41 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.98, y: 5.31 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.39, y: 5.06 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9081657, y: 4.2056403 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.5379853, y: 5.3150578 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.6839943, y: 3.4391232 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4988375, y: 5.1103 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 6.4501343 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.381893, y: 5.18565 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.964919, y: 4.918828 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2140975, y: 4.473684 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_purse4: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.553, y: 4.576 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.553, y: 4.576 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.553, y: 4.576 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.07, y: 4.53 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 69,
          handsType: 1,
        },
        {
          position: { x: -4.07, y: 4.53 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
        {
          position: { x: -4.07, y: 4.53 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 69,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -3.76, y: 5.68 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
        {
          position: { x: -3.92, y: 5.05 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 69,
          handsType: 2,
        },
        {
          position: { x: -3.69, y: 5.57 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 69,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -2.81, y: 5.42 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 79,
          handsType: 0,
        },
        {
          position: { x: -3.17, y: 4.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -2.81, y: 5.42 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 79,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.6, y: 5.01 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 79,
          handsType: 1,
        },
        {
          position: { x: -4.56, y: 4.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 45,
          handsType: 2,
        },
        {
          position: { x: -4.56, y: 4.97 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 45,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.15, y: 4.62 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.65, y: 4.68 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.81, y: 5.55 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.15, y: 5.37 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.7979283, y: 4.4369645 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.2890677, y: 5.862913 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 80,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2328076, y: 4.08157 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 80,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 5.5542245 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.3830886, y: 6.9007726 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.0780697, y: 5.5151024 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.8562217, y: 5.3279877 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.059764, y: 4.410299 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_quintCoin: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.901, y: 5.801 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.901, y: 5.801 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.901, y: 5.801 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 38,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.54, y: 5.27 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 76,
          handsType: 0,
        },
        {
          position: { x: -4.54, y: 5.27 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 76,
          handsType: 2,
        },
        {
          position: { x: -4.54, y: 5.27 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 83,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.44, y: 6.12 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -4.44, y: 6.12 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
        {
          position: { x: -4.44, y: 6.12 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 71,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -2.98, y: 5.56 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -2.72, y: 6.2 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.1, y: 5.55 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 63,
          handsType: 2,
        },
        {
          position: { x: -4.1, y: 5.55 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
        {
          position: { x: -4.41, y: 6.03 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.25, y: 5.3 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.68, y: 5.33 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2, y: 6.02 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.106, y: 6.514 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.990392, y: 5.842381 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.1149597, y: 4.994457 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_remoteControl: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.752, y: 6.064 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.752, y: 6.064 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.752, y: 6.064 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.488, y: 5.971 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.488, y: 5.971 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.488, y: 5.971 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 86,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.44, y: 6.46 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.44, y: 6.46 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.44, y: 6.46 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.28, y: 6.65 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.27, y: 6.08 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.19, y: 6.41 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.06, y: 6.69 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.17, y: 5.87 },
          rotationRadians: -1.4121137,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.17, y: 5.87 },
          rotationRadians: -1.4121137,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.351, y: 5.651 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.79, y: 5.78 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.1, y: 6.6 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 6.43 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.0982404 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.310754, y: 6.8293185 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.1164985 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.0895104, y: 6.6110897 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.8397584, y: 5.9492025 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.053866, y: 5.3347178 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_saw: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.97, y: 8.34 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.68, y: 8.18 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.32, y: 8.15 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.012, y: 7.39 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -5.267, y: 7.383 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.871, y: 7.433 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.03, y: 8.24 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.448, y: 8.19 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -5.03, y: 8.24 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.62, y: 8.07 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.93, y: 7.67 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.93, y: 7.67 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.59, y: 8.21 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -5.798, y: 5.009 },
          rotationRadians: 1.980076,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.62, y: 6.86 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.4, y: 7.44 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.34, y: 7.78 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.63, y: 7.82 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.4214873, y: 6.9698386 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.35034, y: 8.831237 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.427916, y: 7.130413 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.1159084, y: 7.1499596 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.1111727, y: 9.447633 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.2139225, y: 7.97305 },
          rotationRadians: 0.22494353,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.505944, y: 7.3015933 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.937978, y: 6.7293754 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_scissors: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.206, y: 6.726 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
        {
          position: { x: -4.354, y: 6.488 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.338, y: 6.757 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.19, y: 6.4 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
        {
          position: { x: -4.999, y: 6.102 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 2,
        },
        {
          position: { x: -4.9, y: 6.24 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.76, y: 6.76 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 0,
        },
        {
          position: { x: -4.85, y: 6.68 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 2,
        },
        {
          position: { x: -4.85, y: 6.68 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 67,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.56, y: 6.21 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.56, y: 6.21 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.44, y: 6.71 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.31, y: 4.77 },
          rotationRadians: 2.2186529,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.52, y: 5.39 },
          rotationRadians: -4.2622612,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.479, y: 5.814 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.23, y: 5.97 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.47, y: 6.77 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.77, y: 6.65 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 5.85 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.333824, y: 7.433313 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.5836549, y: 6.158683 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.287091, y: 8.147684 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.998, y: 6.344 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.394888, y: 6.0886145 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.693703, y: 5.59288 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_seeing: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.37, y: 6.29 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 42,
          handsType: 0,
        },
        {
          position: { x: -3.37, y: 6.29 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 42,
          handsType: 2,
        },
        {
          position: { x: -3.37, y: 6.29 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 39,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.21, y: 5.82 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 94,
          handsType: 0,
        },
        {
          position: { x: -3.76, y: 5.94 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 88,
          handsType: 2,
        },
        {
          position: { x: -4.11, y: 5.89 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 85,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.27, y: 6.35 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
        {
          position: { x: -3.8, y: 6.46 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 85,
          handsType: 2,
        },
        {
          position: { x: -4.2, y: 6.25 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 87,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 87,
          handsType: 2,
        },
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 87,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.34, y: 6.16 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 87,
          handsType: 1,
        },
        {
          position: { x: -4.34, y: 6.16 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 87,
          handsType: 2,
        },
        {
          position: { x: -4.34, y: 6.16 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.29, y: 5.43 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.56, y: 5.32 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.83, y: 6.27 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 93,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.31, y: 6.44 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 93,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.72, y: 5.15 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 93,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.472763, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.5628386, y: 5.1650906 },
          rotationRadians: 0.11057562,
          scale: { x: 1.15, y: 1.15 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.6466825, y: 7.7937384 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.048, y: 6.481 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 87,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.0219064, y: 5.7434883 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 89,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.78, y: 5.29 },
          rotationRadians: 0.11057562,
          scale: { x: 0.66, y: 0.66 },
          spriteLayerNumber: 116,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_shield: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.45, y: 5.45 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.45, y: 5.45 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.45, y: 5.45 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 35,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.07, y: 4.91 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 72,
          handsType: 2,
        },
        {
          position: { x: -5.07, y: 4.91 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
        {
          position: { x: -5.07, y: 4.91 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 84,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.9, y: 6.16 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 1,
        },
        {
          position: { x: -5.15, y: 5.86 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 2,
        },
        {
          position: { x: -4.9, y: 6.16 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.775, y: 5.877 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.203, y: 5.666 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.203, y: 5.666 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.06, y: 6.23 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 81,
          handsType: 2,
        },
        {
          position: { x: -5.06, y: 6.23 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 83,
          handsType: 0,
        },
        {
          position: { x: -5.06, y: 6.23 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 81,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.769, y: 5.049 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.63, y: 5.48 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.48, y: 5.94 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.92, y: 6.14 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.54, y: 4.69 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.534671, y: 6.3476825 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.178892, y: 4.497859 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.106495, y: 5.7033305 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.4476576, y: 7.1746864 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 65,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.012, y: 6.049 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 84,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.5339365, y: 5.4477453 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.699903, y: 4.7269506 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_soap: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.694, y: 6.046 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 27,
          handsType: 2,
        },
        {
          position: { x: -3.676, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 27,
          handsType: 0,
        },
        {
          position: { x: -3.676, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 35,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.439, y: 5.673 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.439, y: 5.673 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.439, y: 5.673 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 84,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.17, y: 6.5 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
        {
          position: { x: -4.33, y: 6.36 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.02, y: 6.58 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.36, y: 5.861 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.091, y: 6.124 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.14, y: 6.038 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.17, y: 5.58 },
          rotationRadians: 1.4883362,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 64,
          handsType: 2,
        },
        {
          position: { x: -4.17, y: 5.58 },
          rotationRadians: 1.4883362,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 78,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.196, y: 5.368 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.68, y: 5.33 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 6.43 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.8371665, y: 5.099311 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 78,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 78,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 78,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.048, y: 6.481 },
          rotationRadians: -0.16637947,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.852763, y: 5.7351913 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.0511293, y: 4.993823 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_soccerBall: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.99, y: 5.7 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 27,
          handsType: 0,
        },
        {
          position: { x: -4.06, y: 5.34 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 27,
          handsType: 2,
        },
        {
          position: { x: -4.06, y: 5.34 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 38,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.17, y: 5.73 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 101,
          handsType: 1,
        },
        {
          position: { x: -4.392, y: 4.993 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 81,
          handsType: 0,
        },
        {
          position: { x: -4.738, y: 4.955 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 64,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.32, y: 5.89 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 76,
          handsType: 1,
        },
        {
          position: { x: -4.64, y: 5.85 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 72,
          handsType: 2,
        },
        {
          position: { x: -4.64, y: 5.85 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.312, y: 5.899 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.506, y: 5.286 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.302, y: 5.63 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.05, y: 5.27 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 64,
          handsType: 2,
        },
        {
          position: { x: -4.05, y: 5.27 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.33, y: 5.14 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.04, y: 5.13 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.02, y: 5.87 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.43, y: 5.8 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.125975, y: 5.0721107 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.7090406, y: 6.348339 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 4.987839 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.6242788, y: 7.456717 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 69,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.837, y: 5.917 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 93,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.1628556, y: 5.440085 },
          rotationRadians: 0.11057562,
          scale: { x: 0.75, y: 0.75 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.483935, y: 4.85163 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_taco: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.075, y: 5.897 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.075, y: 5.897 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.075, y: 5.897 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 42,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.71, y: 5.8 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
        {
          position: { x: -4.71, y: 5.8 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 70,
          handsType: 2,
        },
        {
          position: { x: -4.71, y: 5.8 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 87,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.44, y: 6.46 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 70,
          handsType: 1,
        },
        {
          position: { x: -4.63, y: 6.22 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 70,
          handsType: 2,
        },
        {
          position: { x: -4.63, y: 6.22 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.31, y: 5.815 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.26, y: 6.429 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.26, y: 6.429 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.45, y: 5.74 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.45, y: 5.74 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.366, y: 5.424 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.68, y: 5.33 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.96, y: 6.24 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.46, y: 6.43 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.5356584, y: 6.594036 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.13 },
          rotationRadians: 0.11057562,
          scale: { x: 1.1, y: 1.1 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.028, y: 6.475 },
          rotationRadians: -0.8679586,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.1208916, y: 5.7479515 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2224946, y: 5.0717587 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_umbrella: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.84, y: 9.27 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -5.06, y: 9.16 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.84, y: 8.85 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 28,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.43, y: 8.47 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
        {
          position: { x: -5.48, y: 8.31 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 70,
          handsType: 2,
        },
        {
          position: { x: -5.42, y: 8.41 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 69,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.82, y: 9.71 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 70,
          handsType: 1,
        },
        {
          position: { x: -4.82, y: 9.71 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 70,
          handsType: 2,
        },
        {
          position: { x: -4.82, y: 9.71 },
          rotationRadians: 0,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.02, y: 8.05 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.63, y: 8.38 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.73, y: 8.31 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.96, y: 9.64 },
          rotationRadians: -0.1369196,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.96, y: 9.64 },
          rotationRadians: -0.1369196,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.96, y: 9.64 },
          rotationRadians: -0.1369196,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.62, y: 7.42 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.29, y: 8.11 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.3, y: 8.36 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.53, y: 8.21 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.302564, y: 7.206453 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.2229285, y: 9.070362 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.640996, y: 7.488474 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.2177157, y: 7.5118823 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.0988765, y: 9.814794 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.084, y: 8.539 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.5853314, y: 7.7368665 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.698661, y: 6.8047585 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_videoGameController: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.91, y: 5.811 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 27,
          handsType: 1,
        },
        {
          position: { x: -4.051, y: 5.645 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 27,
          handsType: 2,
        },
        {
          position: { x: -3.91, y: 5.811 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 27,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.55, y: 4.969 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 76,
          handsType: 2,
        },
        {
          position: { x: -4.641, y: 5.096 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 76,
          handsType: 0,
        },
        {
          position: { x: -4.878, y: 5.197 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 76,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.7, y: 6.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 76,
          handsType: 0,
        },
        {
          position: { x: -4.86, y: 5.76 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 2,
        },
        {
          position: { x: -4.7, y: 6.13 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 76,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.2, y: 5.54 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.37, y: 5.36 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.1, y: 5.84 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.54, y: 5.31 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.54, y: 5.31 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.53, y: 5.61 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.02 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.07, y: 5.02 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.06, y: 5.95 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.53, y: 5.68 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.08, y: 4.84 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.7810826, y: 6.1737404 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.702312, y: 4.492894 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.8066478, y: 5.7678223 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.6947584, y: 7.046415 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.72, y: 6.518 },
          rotationRadians: -0.45086531,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.128, y: 5.496 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2624784, y: 4.874511 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_voilin: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.013, y: 7.255 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.013, y: 7.255 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.013, y: 7.255 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 44,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.552, y: 6.048 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.552, y: 6.048 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.552, y: 6.048 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 90,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.4, y: 7.56 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
        {
          position: { x: -4.5, y: 7.43 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 2,
        },
        {
          position: { x: -4.5, y: 7.43 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 68,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.224, y: 7.191 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
        {
          position: { x: -3.567, y: 6.935 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -3.224, y: 7.191 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.11, y: 6.39 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
        {
          position: { x: -4.03, y: 5.65 },
          rotationRadians: -0.4941843,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -5.62, y: 7.14 },
          rotationRadians: 0.48804724,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.203, y: 5.644 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.85, y: 6.2 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.94, y: 6.87 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.3, y: 6.86 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.37, y: 6.59 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.764125, y: 5.3837757 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.8345437, y: 6.278108 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 8.430897 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.944, y: 5.785 },
          rotationRadians: 0.1253091,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.767, y: 6.111 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.339981, y: 5.60644 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_wand: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.4, y: 7.36 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
        {
          position: { x: -4.4, y: 7.36 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.4, y: 7.36 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.73, y: 6.53 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.73, y: 6.53 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.73, y: 6.53 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.69, y: 7.92 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.47, y: 7.96 },
          rotationRadians: -0.16842441,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -4.43, y: 8.22 },
          rotationRadians: -0.16842441,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.58, y: 8.23 },
          rotationRadians: -0.079051912,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.01, y: 7.84 },
          rotationRadians: -0.079051912,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.54, y: 8.25 },
          rotationRadians: -0.079051912,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.85, y: 7.8 },
          rotationRadians: -0.26771286,
          scale: { x: 0.9, y: 0.77687997 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.85, y: 7.8 },
          rotationRadians: -0.26771286,
          scale: { x: 0.9, y: 0.77687997 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
      ],
      [
        {
          position: { x: -4.691, y: 6.734 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.6, y: 7.44 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.09, y: 7.39 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.92, y: 7.99 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.2133965, y: 6.285437 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.5665135, y: 8.069386 },
          rotationRadians: -0.06128823,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.84897, y: 6.387388 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.0585597, y: 6.912819 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.1337676, y: 8.990048 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.604643, y: 7.728406 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.337706, y: 6.959902 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.400653, y: 5.9024115 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_watermelon: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -4.315, y: 5.517 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -4.547, y: 5.384 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -4.547, y: 5.384 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 34,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -5.06, y: 5.51 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 85,
          handsType: 1,
        },
        {
          position: { x: -5.08, y: 5.03 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 64,
          handsType: 2,
        },
        {
          position: { x: -5.08, y: 5.03 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.44, y: 6.46 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
        {
          position: { x: -4.68, y: 5.76 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 2,
        },
        {
          position: { x: -4.49, y: 5.95 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 70,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.42, y: 6.05 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -3.77, y: 5.48 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.42, y: 6.05 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.73, y: 6.43 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.74, y: 5.27 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -4.74, y: 5.27 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.359, y: 5.198 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.31, y: 4.99 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -6.32, y: 5.89 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.68, y: 5.88 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.33, y: 4.82 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.946571, y: 6.128294 },
          rotationRadians: -0.098812012,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.1134386, y: 4.33216 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.0204997, y: 5.670652 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.8511178, y: 7.200694 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.954, y: 6.55 },
          rotationRadians: -1.5984279,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.3383074, y: 5.376909 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.491817, y: 4.714751 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_weightsForEachHand: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.752, y: 6.064 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.506, y: 6.405 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
        {
          position: { x: -3.61, y: 6.329 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.237, y: 5.977 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.237, y: 5.977 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -4.237, y: 5.977 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -3.83, y: 6.73 },
          rotationRadians: -0.31842578,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -4.22, y: 6.31 },
          rotationRadians: -0.075889169,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 2,
        },
        {
          position: { x: -3.74, y: 6.69 },
          rotationRadians: -0.19016513,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -2.919, y: 6.162 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -2.87, y: 6.44 },
          rotationRadians: -0.24320473,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
        {
          position: { x: -2.87, y: 6.44 },
          rotationRadians: -0.24320473,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.302, y: 5.715 },
          rotationRadians: -1.3858736,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.302, y: 5.715 },
          rotationRadians: -1.3858736,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 2,
        },
        {
          position: { x: -4.302, y: 5.715 },
          rotationRadians: -1.3858736,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.076, y: 5.424 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.63, y: 5.6 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.6, y: 6.52 },
          rotationRadians: -0.44301188,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.23, y: 6.39 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.062463, y: 6.988589 },
          rotationRadians: -0.18201646,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.3702936, y: 5.2741475 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.51, y: 7.72 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.189, y: 6.452 },
          rotationRadians: 0,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.777093, y: 5.923008 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.044697, y: 5.341256 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_wineGlass: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.687, y: 6.648 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
        {
          position: { x: -3.687, y: 6.648 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.687, y: 6.648 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.36, y: 6.56 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
        {
          position: { x: -4.36, y: 6.56 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -4.33, y: 6.17 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 73,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.38, y: 6.96 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -4.38, y: 6.96 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
        {
          position: { x: -4.09, y: 7.21 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 73,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -2.908, y: 6.544 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.085, y: 6.469 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -2.832, y: 6.598 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.87, y: 6.62 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.22, y: 5.92 },
          rotationRadians: -0.83831888,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 62,
          handsType: 2,
        },
        {
          position: { x: -4.22, y: 5.92 },
          rotationRadians: -0.83831888,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.054, y: 5.913 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.68, y: 6.2 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.74, y: 6.81 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.12, y: 6.82 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.9, y: 5.38 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.1057925, y: 7.0784144 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.6735296, y: 5.8383775 },
          rotationRadians: 0.33546488,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.4588, y: 6.0393 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.481722, y: 8.275954 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.319, y: 7.059 },
          rotationRadians: 0.27468559,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.767, y: 6.266303 },
          rotationRadians: 0.11057562,
          scale: { x: 0.65, y: 0.65 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.0451965, y: 5.510795 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
  holdingRight_wrench: {
    avatarGroup: 3,
    avatarItemsSubGroup: 14,
    perCharacter: [
      [
        {
          position: { x: -3.687, y: 6.648 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 1,
        },
        {
          position: { x: -3.687, y: 6.648 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 24,
          handsType: 2,
        },
        {
          position: { x: -3.687, y: 6.648 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 24,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.36, y: 6.56 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
        {
          position: { x: -4.36, y: 6.56 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -4.33, y: 6.17 },
          rotationRadians: 0.11057562,
          scale: { x: 1, y: 1 },
          spriteLayerNumber: 73,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -4.38, y: 6.96 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 73,
          handsType: 2,
        },
        {
          position: { x: -4.028, y: 7.032 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 73,
          handsType: 0,
        },
        {
          position: { x: -4.09, y: 7.21 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 73,
          handsType: 1,
        },
      ],
      [
        {
          position: { x: -2.908, y: 6.544 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -3.085, y: 6.469 },
          rotationRadians: 0.11057562,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 77,
          handsType: 2,
        },
        {
          position: { x: -3.076, y: 6.735 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 77,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.87, y: 6.62 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 77,
          handsType: 1,
        },
        {
          position: { x: -4.22, y: 5.92 },
          rotationRadians: -0.83831888,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 62,
          handsType: 2,
        },
        {
          position: { x: -4.43, y: 5.731 },
          rotationRadians: -0.83831888,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.21, y: 5.85 },
          rotationRadians: 0,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 70,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.99, y: 6.37 },
          rotationRadians: 0,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 41,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.9, y: 6.65 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.39, y: 6.79 },
          rotationRadians: 0,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.26251, y: 5.917548 },
          rotationRadians: 0,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 68,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -5.5264635, y: 7.1484437 },
          rotationRadians: 0.11058406,
          scale: { x: 0.8, y: 0.8 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.57, y: 5.9047213 },
          rotationRadians: 0.11057562,
          scale: { x: 0.9, y: 0.9 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -2.778183, y: 6.4523354 },
          rotationRadians: 0.11057562,
          scale: { x: 0.5, y: 0.5 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -3.4058578, y: 7.810145 },
          rotationRadians: 0.11057562,
          scale: { x: 0.7, y: 0.7 },
          spriteLayerNumber: 72,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.4023066, y: 7.0408177 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 75,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.839131, y: 6.0973926 },
          rotationRadians: 0.11057562,
          scale: { x: 0.6, y: 0.6 },
          spriteLayerNumber: 71,
          handsType: 0,
        },
      ],
      [
        {
          position: { x: -4.108674, y: 5.5735745 },
          rotationRadians: 0.11057562,
          scale: { x: 0.55, y: 0.55 },
          spriteLayerNumber: 74,
          handsType: 0,
        },
      ],
    ],
  },
};
